;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="7ab53e29-103a-4634-9f4b-64f1f090c357",e._sentryDebugIdIdentifier="sentry-dbid-7ab53e29-103a-4634-9f4b-64f1f090c357")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2358],{

/***/ 71109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_CheckOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
// This icon file is generated automatically.
var CheckOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
      }
    }]
  },
  "name": "check",
  "theme": "outlined"
};
/* harmony default export */ var asn_CheckOutlined = (CheckOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var CheckOutlined_CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_CheckOutlined
  }));
};

/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/react.forwardRef(CheckOutlined_CheckOutlined);
if (false) {}
/* harmony default export */ var icons_CheckOutlined = (RefIcon);

/***/ }),

/***/ 54213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_UploadOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/UploadOutlined.js
// This icon file is generated automatically.
var UploadOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "64 64 896 896",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
      }
    }]
  },
  "name": "upload",
  "theme": "outlined"
};
/* harmony default export */ var asn_UploadOutlined = (UploadOutlined);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(92902);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var UploadOutlined_UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref,
    icon: asn_UploadOutlined
  }));
};

/**![upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQwMCAzMTcuN2g3My45VjY1NmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjMxNy43SDYyNGM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1MTguMyAxNjNhOCA4IDAgMDAtMTIuNiAwbC0xMTIgMTQxLjdjLTQuMSA1LjMtLjQgMTMgNi4zIDEzek04NzggNjI2aC02MGMtNC40IDAtOCAzLjYtOCA4djE1NEgyMTRWNjM0YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxOThjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjg0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjYzNGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/react.forwardRef(UploadOutlined_UploadOutlined);
if (false) {}
/* harmony default export */ var icons_UploadOutlined = (RefIcon);

/***/ }),

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 71941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[page]",
      function () {
        return __webpack_require__(35267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

var ErrorMessage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(className, "  ml-4 mt-1 flex items-start gap-1.5 text-sm font-normal leading-4.5 text-state-error"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "mt-[1px] flex-none",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M7.7 7.7H6.3V3.5H7.7M7.7 10.5H6.3V9.1H7.7M7 0C6.08075 0 5.17049 0.18106 4.32122 0.532843C3.47194 0.884626 2.70026 1.40024 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85651 0.737498 10.637 2.05025 11.9497C2.70026 12.5998 3.47194 13.1154 4.32122 13.4672C5.17049 13.8189 6.08075 14 7 14C8.85651 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85651 14 7C14 6.08075 13.8189 5.17049 13.4672 4.32122C13.1154 3.47194 12.5998 2.70026 11.9497 2.05025C11.2997 1.40024 10.5281 0.884626 9.67878 0.532843C8.8295 0.18106 7.91925 0 7 0Z",
                        fill: "#D35563"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex-auto first-letter:uppercase",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorMessage);


/***/ }),

/***/ 22338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function useCountdown(minutes) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(minutes * 60 + seconds), time = ref[0], setTime = ref[1];
    var endTimeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var resetTime = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newMinutes) {
        var newSeconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var newTime = newMinutes * 60 + newSeconds;
        setTime(newTime);
        endTimeRef.current = Date.now() + newTime * 1000 // Cập nhật thời gian kết thúc
        ;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (endTimeRef.current === null) {
            endTimeRef.current = Date.now() + time * 1000 // Thiết lập endTime khi khởi tạo
            ;
        }
        var updateRemainingTime = function() {
            if (endTimeRef.current) {
                var remainingTime = Math.max(Math.floor((endTimeRef.current - Date.now()) / 1000), 0);
                setTime(remainingTime);
                if (remainingTime === 0) {
                    clearInterval(intervalId);
                }
            }
        };
        var intervalId = setInterval(updateRemainingTime, 1000);
        updateRemainingTime() // Cập nhật lần đầu ngay khi vào useEffect
        ;
        return function() {
            return clearInterval(intervalId);
        };
    }, []);
    var formatTime = function() {
        var mins = Math.floor(time / 60);
        var secs = time % 60;
        return "".concat(mins.toString().padStart(2, "0"), ":").concat(secs.toString().padStart(2, "0"));
    };
    return [
        formatTime(),
        resetTime,
        time
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useCountdown);


/***/ }),

/***/ 27019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57368);


var SAPPLabel = function(param) {
    var title = param.title, required = param.required, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("mb-2.5 block text-sm font-medium", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                required: required
            }),
            children: title
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SAPPLabel);


/***/ }),

/***/ 78959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _checkbox_SAPPCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19786);


var SappTable = function(param) {
    var children = param.children, headers = param.headers, isCheckedAll = param.isCheckedAll, onChange = param.onChange, _hasCheckAll = param.hasCheckAll, hasCheckAll = _hasCheckAll === void 0 ? true : _hasCheckAll, _hasCheck = param.hasCheck, hasCheck = _hasCheck === void 0 ? true : _hasCheck, _showHeader = param.showHeader, showHeader = _showHeader === void 0 ? true : _showHeader, _showHashtag = param.showHashtag, showHashtag = _showHashtag === void 0 ? false : _showHashtag, classTableRes = param.classTableRes, _classTable = param.classTable, classTable = _classTable === void 0 ? "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" : _classTable, theadClass = param.theadClass, _tbodyClass = param.tbodyClass, tbodyClass = _tbodyClass === void 0 ? "" : _tbodyClass, _classString = param.classString, classString = _classString === void 0 ? "" : _classString;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "table-responsive relative overflow-x-auto ".concat(classTableRes),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
            className: classTable,
            children: [
                showHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                    className: "".concat(theadClass),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        className: "text-muted fw-bolder fs-7 text-uppercase gs-0 text-start ".concat(classString),
                        children: [
                            hasCheck && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                className: "w-50px pr-5",
                                scope: "col",
                                children: hasCheckAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_checkbox_SAPPCheckbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    checked: isCheckedAll,
                                    onChange: onChange
                                })
                            }),
                            showHashtag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                className: "w-40px",
                                style: {
                                    lineHeight: "12px"
                                },
                                children: "#"
                            }),
                            headers === null || headers === void 0 ? void 0 : headers.map(function(column) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                    className: "".concat(column.className, " fs-7 fw-bold pr-4"),
                                    children: column.label
                                }, column.label);
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                    className: "fw-semibold text-bw-1 ".concat(tbodyClass),
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SappTable);


/***/ }),

/***/ 19786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);


var STATE = {
    success: "checked:bg-state-success checked:hover:bg-state-success checked:focus:bg-state-success",
    error: "checked:bg-state-error checked:hover:bg-state-error checked:focus:bg-state-error",
    default: "checked:bg-bw-1 checked:hover:bg-bw-1 checked:focus:bg-bw-1",
    primary: "checked:bg-primary checked:hover:bg-primary checked:focus:bg-primary"
};
var SIZES = {
    small: "w-4.5 h-4.5",
    medium: "w-[24px] h-[24px]",
    lager: "w-[30px] h-[30px]"
};
var SAPPCheckbox = function(param) {
    var checked = param.checked, disabled = param.disabled, onChange = param.onChange, className = param.className, value = param.value, _state = param.state, state = _state === void 0 ? "default" : _state, _size = param.size, size = _size === void 0 ? "medium" : _size, _lowerOptions = param.lowerOptions, lowerOptions = _lowerOptions === void 0 ? false : _lowerOptions, _inputStyle = param.inputStyle, inputStyle = _inputStyle === void 0 ? "border-bw-1" : _inputStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
            className: "block ".concat(SIZES[size], " border-1.5 outline-none ring-0 ring-offset-0 focus:outline-none focus:ring-0 focus:ring-offset-0 ").concat(inputStyle, " ").concat(STATE[state], " ").concat(disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer", " ").concat(lowerOptions && "border-none"),
            type: "checkbox",
            checked: checked,
            onChange: onChange,
            disabled: disabled,
            value: value === null || value === void 0 ? void 0 : value.toString()
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SAPPCheckbox);


/***/ }),

/***/ 47945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);




var PageLink = function(_param) {
    var active = _param.active, disabled = _param.disabled, arrow = _param.arrow, type = _param.type, children = _param.children, isViewedProp = _param.isViewedProp, isFlagedProp = _param.isFlagedProp, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "active",
        "disabled",
        "arrow",
        "type",
        "children",
        "isViewedProp",
        "isFlagedProp"
    ]);
    // const [isViewed, setIsViewed] = useState<boolean>(false)
    // useEffect(() => {
    //   if (isViewedProp !== undefined) {
    //     setIsViewed(isViewedProp)
    //   }
    // }, [isViewedProp])
    if (arrow && disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "flex cursor-not-allowed items-center justify-center p-0.5 ".concat(type === "table" ? "min-h-8 min-w-8 text-gray-6" : "min-h-default text-gray-1"),
            children: children
        });
    } else if (arrow) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            className: "".concat(type === "table" ? "min-h-8 min-w-8 text-gray-5" : "min-h-default", " flex cursor-pointer items-center justify-center p-0.5")
        }, otherProps), {
            children: children
        }));
    }
    if (disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "flex items-center justify-center ".concat(type === "table" ? "min-h-8 min-w-8 text-gray-5" : "min-h-default text-3xl font-thin leading-8.5 text-gray-1 "),
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "".concat(type === "table" ? "min-h-8 min-w-8 rounded-md text-xsm font-semibold leading-4.8" : "min-h-default min-w-default border text-sm font-normal leading-8.5", " relative flex cursor-pointer items-center justify-center p-0.5\n      ").concat(isViewedProp && type !== "row" ? "!border-default bg-gray-3" : "", " ").concat(active ? "border-active bg-primary text-white" : !isViewedProp ? "border-default bg-white text-gray-1 hover:border-active hover:bg-primary hover:text-white" : "border-gray-2 text-gray-1 hover:border-active hover:bg-primary hover:text-white"),
        "aria-current": active ? "page" : undefined
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "h-full w-full text-center",
                children: children
            }),
            isFlagedProp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "absolute right-1 top-1 h-2 w-2 rounded-full bg-gray-1"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PageLink);


/***/ }),

/***/ 47394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pagination_PaginationSAPP; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
;// CONCATENATED MODULE: ./src/components/common/pagination.ts
function getPaginationItems(currentPage, lastPage, maxLength) {
    var res = [];
    // handle lastPage less than maxLength
    if (lastPage <= maxLength) {
        for(var i = 1; i <= lastPage; i++){
            res.push(i);
        }
    } else {
        var firstPage = 1;
        var confirmedPagesCount = 3;
        var deductedMaxLength = maxLength - confirmedPagesCount;
        var sideLength = deductedMaxLength / 2;
        // handle ellipsis in the middle
        if (currentPage - firstPage < sideLength || lastPage - currentPage < sideLength) {
            for(var j = 1; j <= sideLength + firstPage; j++){
                res.push(j);
            }
            res.push(NaN);
            for(var k = lastPage - sideLength; k <= lastPage; k++){
                res.push(k);
            }
        } else if (currentPage - firstPage >= deductedMaxLength && lastPage - currentPage >= deductedMaxLength) {
            var deductedSideLength = sideLength - 1;
            res.push(1);
            res.push(NaN);
            for(var l = currentPage - deductedSideLength; l <= currentPage + deductedSideLength; l++){
                res.push(l);
            }
            res.push(NaN);
            res.push(lastPage);
        } else {
            var isNearFirstPage = currentPage - firstPage < lastPage - currentPage;
            var remainingLength = maxLength;
            if (isNearFirstPage) {
                for(var m = 1; m <= currentPage + 1; m++){
                    res.push(m);
                    remainingLength -= 1;
                }
                res.push(NaN);
                remainingLength -= 1;
                for(var n = lastPage - (remainingLength - 1); n <= lastPage; n++){
                    res.push(n);
                }
            } else {
                for(var o = lastPage; o >= currentPage - 1; o--){
                    res.unshift(o);
                    remainingLength -= 1;
                }
                res.unshift(NaN);
                remainingLength -= 1;
                for(var p = remainingLength; p >= 1; p--){
                    res.unshift(p);
                }
            }
        }
    }
    return res;
}

// EXTERNAL MODULE: ./src/components/base/pagination/PageLink.tsx
var PageLink = __webpack_require__(47945);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/components/base/pagination/ArrowIcon.tsx
var ArrowIcon = __webpack_require__(4633);
;// CONCATENATED MODULE: ./src/components/base/pagination/Pagination.tsx






var Pagination = function(param) {
    var currentPage = param.currentPage, pageSize = param.pageSize, maxLength = param.maxLength, setCurrentPage = param.setCurrentPage, totalItems = param.totalItems, type = param.type, optionShowAll = param.optionShowAll;
    var elementRef = (0,react.useRef)(null);
    var ref = (0,react.useState)([]), pageNums = ref[0], setPageNums = ref[1];
    var ref1 = (0,react.useState)(true), activeShowAll = ref1[0], setActiveShowAll = ref1[1];
    var getPagination = getPaginationItems(currentPage, pageSize, maxLength);
    var arrPage = [];
    for(var i = 1; i <= totalItems; i++){
        arrPage.push(i);
    }
    var handleHorizantalScroll = function(element, speed, distance, step) {
        var scrollAmount = 0;
        var slideTimer = setInterval(function() {
            element.scrollLeft += step;
            scrollAmount += Math.abs(step);
            if (scrollAmount >= distance) {
                clearInterval(slideTimer);
            }
        // if (element.scrollLeft === 0) {
        //   setArrowDisable(true);
        // } else {
        //   setArrowDisable(false);
        // }
        }, speed);
    };
    (0,react.useEffect)(function() {
        setPageNums(getPaginationItems(currentPage, pageSize, maxLength));
    }, [
        pageSize,
        currentPage,
        maxLength
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "pagination flex flex-wrap items-center ".concat(type === "row" && "w-full", " ").concat(type === "table" ? "gap-5" : "gap-3"),
        "aria-label": "Pagination",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(type === "row" && activeShowAll ? "relative mx-7 w-[calc(100%-141px)]" : " flex items-center gap-6"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(type === "row" && activeShowAll && "absolute -left-3 top-0.5 -translate-x-full"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink/* default */.Z, {
                        disabled: type !== "row" && currentPage === 1,
                        arrow: true,
                        onClick: function() {
                            if (type === "row") {
                                handleHorizantalScroll(elementRef.current, 25, 200, -20);
                            } else if (setCurrentPage !== undefined) {
                                setCurrentPage(currentPage - 1);
                            }
                        },
                        type: type,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                            iconType: "".concat(type === "table" ? "chervon" : "teeny")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(type === "row" && activeShowAll ? "flex w-full gap-2 overflow-hidden" : "flex flex-wrap items-center gap-2"),
                    ref: elementRef,
                    children: pageNums.map(function(pageNum, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink/* default */.Z, {
                            active: currentPage === pageNum,
                            disabled: isNaN(pageNum),
                            onClick: function() {
                                if (setCurrentPage !== undefined) {
                                    setCurrentPage(pageNum);
                                }
                            },
                            type: type,
                            children: !isNaN(pageNum) ? pageNum : type === "table" ? "..." : "|"
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(type === "row" && activeShowAll && "absolute -right-3 top-0.5 translate-x-full"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink/* default */.Z, {
                        disabled: type !== "row" && currentPage === pageSize,
                        arrow: true,
                        onClick: function() {
                            if (type === "row") {
                                handleHorizantalScroll(elementRef.current, 25, 200, 20);
                            } else if (setCurrentPage !== undefined) {
                                setCurrentPage(currentPage + 1);
                            }
                        },
                        type: type,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                            iconType: "".concat(type === "table" ? "chervon" : "teeny"),
                            right: true
                        })
                    })
                }),
                type === "row" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        !activeShowAll && optionShowAll,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-6 w-max cursor-pointer text-sm font-semibold leading-4.5 text-bw-1 underline ".concat(activeShowAll && "absolute -right-28 top-0 translate-y-1/2 "),
                            onClick: function() {
                                setPageNums(activeShowAll ? arrPage : getPagination);
                                setActiveShowAll(!activeShowAll);
                            },
                            children: activeShowAll ? "Show All" : "Show Less"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pagination_Pagination = (Pagination);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
;// CONCATENATED MODULE: ./src/components/base/pagination/PaginationSAPP.tsx



var PaginationSAPP = function(param) {
    var currentPage = param.currentPage, pageSize = param.pageSize, setCurrentPage = param.setCurrentPage, setPageSize = param.setPageSize, totalItems = param.totalItems, type = param.type, optionShowAll = param.optionShowAll, classname = param.classname;
    var options = [
        {
            value: 10,
            label: "10"
        },
        {
            value: 25,
            label: "25"
        },
        {
            value: 50,
            label: "50"
        },
        {
            value: 100,
            label: "100"
        }, 
    ];
    var handlePageChange = function(size) {
        setCurrentPage && setCurrentPage(1);
        setPageSize && setPageSize(size);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex flex-wrap items-center justify-center gap-4 overflow-hidden md:justify-between", classname),
            children: [
                type === "table" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-2.5 text-xsm text-gray-1",
                            children: "Show"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "w-[70px] cursor-pointer border-0 bg-gray-4 px-2.5 py-1 shadow-0",
                            onChange: function(e) {
                                var pageNumber = parseInt(e.target.value);
                                handlePageChange(pageNumber);
                            },
                            children: options.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, option.value);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "ml-2.5 text-xsm text-gray-1",
                            children: [
                                "of ",
                                totalItems,
                                " entries"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination_Pagination, {
                    currentPage: currentPage,
                    setCurrentPage: setCurrentPage,
                    pageSize: Math.ceil(totalItems / pageSize),
                    maxLength: "".concat(type === "table" ? 9 : totalItems),
                    totalItems: totalItems,
                    type: type,
                    optionShowAll: optionShowAll
                })
            ]
        })
    });
};
/* harmony default export */ var pagination_PaginationSAPP = (PaginationSAPP);


/***/ }),

/***/ 70745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75367);
/* harmony import */ var src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68507);
/* harmony import */ var _SAPPTextFiled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41012);





var HookFormTextField = function(param) {
    var name = param.name, control = param.control, defaultValue = param.defaultValue, onChange = param.onChange, type = param.type, placeholder = param.placeholder, _className = param.className, className = _className === void 0 ? "" : _className, disabled = param.disabled, label = param.label, labelClass = param.labelClass, skeleton = param.skeleton, required = param.required, maxLength = param.maxLength, textSize = param.textSize, inputClassName = param.inputClassName, style = param.style, placeholderIcon = param.placeholderIcon, onBlur = param.onBlur, onFocus = param.onFocus;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var _value, ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-full w-full",
                children: !skeleton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SAPPTextFiled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            type: type,
                            textSize: textSize,
                            value: (_value = field.value) !== null && _value !== void 0 ? _value : "",
                            defaultValue: field.value ? undefined : defaultValue,
                            onChange: function(value) {
                                field.onChange(value);
                                onChange && onChange(value);
                            },
                            className: "".concat(className, " ").concat(error ? "border-error focus:border-error" : "border-default focus:border-focus "),
                            placeholder: placeholder,
                            disabled: disabled,
                            label: label,
                            labelClass: labelClass,
                            required: required,
                            maxLength: maxLength,
                            field: field,
                            style: style,
                            isError: !!(error === null || error === void 0 ? void 0 : error.message),
                            inputClassName: inputClassName,
                            placeholderIcon: placeholderIcon,
                            onBlur: onBlur,
                            onFocus: onFocus
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_ErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    children: (ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : ""
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center",
                    children: "Loading..."
                })
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HookFormTextField);


/***/ }),

/***/ 41012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37559);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57368);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _Label_SAPPLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27019);






var TEXT_SIZES = {
    base: "text-base placeholder:text-base",
    sm: "text-medium-sm placeholder:text-medium-sm"
};
var SAPPTextFiled = function(param) {
    var inputRef = param.inputRef, type = param.type, value = param.value, defaultValue = param.defaultValue, onChange = param.onChange, className = param.className, inputClassName = param.inputClassName, placeholder = param.placeholder, placeholderIcon = param.placeholderIcon, disabled = param.disabled, label = param.label, _labelClass = param.labelClass, labelClass = _labelClass === void 0 ? "text-base block font-medium mb-2" : _labelClass, required = param.required, maxLength = param.maxLength, field = param.field, _textSize = param.textSize, textSize = _textSize === void 0 ? "base" : _textSize, isError = param.isError, style = param.style, onPaste = param.onPaste, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Label_SAPPLabel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: label,
                className: labelClass,
                required: required
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(className !== null && className !== void 0 ? className : "", " relative flex w-full items-center"),
                children: [
                    placeholderIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute left-4 text-gray-500",
                        children: placeholderIcon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, field), {
                        ref: inputRef,
                        type: type == "password" ? showPassword ? "text" : "password" : type,
                        value: value !== null && value !== void 0 ? value : "",
                        defaultValue: value ? defaultValue : undefined,
                        onChange: onChange,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(inputClassName, TEXT_SIZES[textSize], "form-control h-[50px] w-full border border-solid border-default px-4 py-3 font-medium text-bw-1 shadow-0 placeholder:font-medium placeholder:text-gray-1 focus:border-primary focus:shadow-0 focus:outline-none", {
                            "!border-error": isError,
                            "bg-gray-4": disabled,
                            "bg-transparent": !disabled,
                            "pl-12": placeholderIcon
                        }),
                        placeholder: placeholder,
                        disabled: disabled,
                        style: style,
                        maxLength: maxLength,
                        onPaste: onPaste,
                        onFocus: onFocus,
                        onBlur: onBlur
                    })),
                    type == "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(showPassword ? "bg-show-password" : "bg-hide-password", " absolute right-4 top-2/4 h-4 max-h-4 min-h-4 w-4 min-w-4 max-w-4 -translate-y-2/4 cursor-pointer"),
                        onClick: function() {
                            return setShowPassword(!showPassword);
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SAPPTextFiled);


/***/ }),

/***/ 83251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);

function CertificateImg(param) {
    var className = param.className, _size = param.size, size = _size === void 0 ? 40 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.389 10.7148H8.61131C8.2874 10.7148 8.0249 10.9773 8.0249 11.3012C8.0249 11.6252 8.2874 11.8877 8.61131 11.8877H31.389C31.7129 11.8877 31.9754 11.6252 31.9754 11.3012C31.9754 10.9773 31.7129 10.7148 31.389 10.7148Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.389 17.0996H8.61131C8.2874 17.0996 8.0249 17.3621 8.0249 17.686C8.0249 18.0098 8.2874 18.2724 8.61131 18.2724H31.389C31.7129 18.2724 31.9754 18.0099 31.9754 17.686C31.9754 17.3621 31.7129 17.0996 31.389 17.0996Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23.9212 21.2422H16.0786C15.7547 21.2422 15.4922 21.5047 15.4922 21.8286C15.4922 22.1524 15.7547 22.415 16.0786 22.415H23.9212C24.2452 22.415 24.5077 22.1525 24.5077 21.8286C24.5077 21.5047 24.2452 21.2422 23.9212 21.2422Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.3891 13.8945H14.3989C14.075 13.8945 13.8125 14.157 13.8125 14.4809C13.8125 14.8048 14.075 15.0673 14.3989 15.0673H31.3891C31.713 15.0673 31.9755 14.8048 31.9755 14.4809C31.9755 14.157 31.713 13.8945 31.3891 13.8945Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.6705 13.8926H8.61131C8.2874 13.8926 8.0249 14.1551 8.0249 14.479C8.0249 14.8029 8.2874 15.0654 8.61131 15.0654H11.6705C11.9944 15.0654 12.2569 14.8029 12.2569 14.479C12.2569 14.1552 11.9944 13.8926 11.6705 13.8926Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M36.9729 9.72398C36.8365 9.59 36.656 9.51625 36.4634 9.51625C36.4632 9.51625 36.4632 9.51625 36.463 9.51625C35.2745 9.51625 34.3018 8.58719 34.2482 7.40078C34.2307 7.015 33.9136 6.71289 33.5265 6.71289H6.33434C5.94715 6.71289 5.63004 7.01508 5.61254 7.40117C5.56152 8.53484 4.63348 9.46297 3.49973 9.51398C3.11379 9.53133 2.81152 9.84844 2.81152 10.2358V25.3937C2.81152 25.781 3.11379 26.098 3.49973 26.1154C4.63348 26.1665 5.56152 27.0945 5.61254 28.2286C5.63012 28.6144 5.94723 28.9165 6.33434 28.9165H23.645C23.9689 28.9165 24.2314 28.654 24.2314 28.3301C24.2314 28.0063 23.9689 27.7437 23.645 27.7437H6.73762C6.4952 26.3312 5.39668 25.2327 3.98426 24.9902V10.639C5.39668 10.3966 6.4952 9.29781 6.73762 7.88563H33.1235C33.3758 9.34266 34.5489 10.4673 36.0161 10.6598V20.6184C36.0161 20.9422 36.2786 21.2048 36.6025 21.2048C36.9264 21.2048 37.1889 20.9423 37.1889 20.6184V10.2391C37.1889 10.0438 37.1122 9.86086 36.9729 9.72398Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M38.3723 3.78516H1.62773C0.730234 3.78516 0 4.51539 0 5.41289V30.2152C0 31.1128 0.730234 31.843 1.62773 31.843H26.2409L25.3695 33.669C25.2575 33.9034 25.2848 34.1784 25.4404 34.3863C25.5961 34.5944 25.8523 34.6977 26.1086 34.6567L27.7309 34.3959L28.6359 35.8813C28.7627 36.0898 28.9882 36.2155 29.2305 36.2155C29.2423 36.2155 29.2541 36.2152 29.266 36.2146C29.5216 36.2016 29.7489 36.0501 29.8593 35.819L31.4316 32.5242L33.0038 35.8187C33.114 36.0498 33.3412 36.2016 33.597 36.2147C33.6089 36.2153 33.6209 36.2156 33.6328 36.2156C33.8751 36.2156 34.1005 36.0898 34.2274 35.8815L35.1323 34.3961L36.7547 34.6569C37.0118 34.698 37.2675 34.5944 37.423 34.3862C37.5787 34.1781 37.6057 33.9033 37.4938 33.6692L36.6223 31.8432H38.3723C39.2698 31.8432 40 31.113 40 30.2155V5.41289C40 4.51539 39.2698 3.78516 38.3723 3.78516ZM29.1798 34.5199L28.5659 33.5125C28.4181 33.2698 28.1414 33.1422 27.8606 33.1873L26.8189 33.3548L27.9163 31.0554C28.3488 31.4967 28.9649 31.7352 29.6045 31.6749C29.8232 31.654 30.0424 31.7129 30.2216 31.8402C30.2806 31.8822 30.342 31.9195 30.4041 31.9546L29.1798 34.5199ZM31.5715 31.0427C31.5697 31.043 31.5679 31.0431 31.566 31.0434C31.4771 31.0566 31.3867 31.0566 31.2978 31.0435C31.2955 31.0432 31.2933 31.043 31.2911 31.0427C31.1534 31.0213 31.0195 30.9686 30.9009 30.8843C30.5462 30.6321 30.1227 30.498 29.6906 30.498C29.6252 30.498 29.5595 30.5012 29.4939 30.5073C29.1057 30.544 28.7369 30.3308 28.5748 29.9767C28.5029 29.8195 28.4111 29.6741 28.3045 29.541C28.2998 29.5344 28.2947 29.5281 28.2898 29.5217C28.2838 29.5145 28.2783 29.5071 28.2723 29.5C28.2655 29.492 28.2584 29.4845 28.2512 29.4769C28.0573 29.2537 27.8177 29.0716 27.5448 28.9467C27.1906 28.7847 26.9774 28.4153 27.0141 28.0276C27.0613 27.5287 26.9275 27.029 26.6372 26.6206C26.4115 26.3032 26.4115 25.8767 26.6371 25.5593C26.9275 25.1509 27.0613 24.6512 27.0141 24.1523C26.9774 23.7646 27.1907 23.3952 27.5448 23.2332C28.0005 23.0247 28.3662 22.6589 28.5748 22.2032C28.7369 21.8491 29.107 21.6358 29.4939 21.6726C29.9934 21.7197 30.4926 21.5859 30.9009 21.2955C31.2184 21.0699 31.6449 21.0699 31.9623 21.2955C32.3707 21.5859 32.87 21.7194 33.3693 21.6726C33.7573 21.6357 34.1265 21.8491 34.2885 22.2032C34.497 22.6589 34.8628 23.0247 35.3184 23.2331C35.6726 23.3952 35.8859 23.7646 35.8491 24.1523C35.802 24.6512 35.9358 25.1509 36.2261 25.5592C36.4518 25.8766 36.4518 26.3031 36.2261 26.6205C35.9358 27.029 35.802 27.5287 35.8491 28.0275C35.8859 28.4152 35.6726 28.7846 35.3184 28.9467C35.0461 29.0713 34.807 29.253 34.6134 29.4755C34.6054 29.4837 34.5976 29.4921 34.5902 29.5008C34.5852 29.5069 34.5804 29.5132 34.5753 29.5194C34.5695 29.5269 34.5635 29.5342 34.558 29.5419C34.4518 29.6748 34.3602 29.8199 34.2885 29.9767C34.1264 30.3308 33.757 30.5441 33.3693 30.5073C32.8709 30.4604 32.3709 30.594 31.9623 30.8843C31.8435 30.9687 31.7095 31.0215 31.5715 31.0427ZM35.0026 33.1872C34.7217 33.1423 34.4452 33.2698 34.2973 33.5126L33.6835 34.52L32.4592 31.9546C32.5213 31.9195 32.5826 31.8822 32.6417 31.8402C32.8209 31.7128 33.0403 31.6537 33.2588 31.6748C33.8986 31.7352 34.5146 31.4967 34.9471 31.0554L36.0444 33.3547L35.0026 33.1872ZM38.8273 30.2153C38.8273 30.4662 38.6232 30.6703 38.3723 30.6703H36.0627L35.7603 30.0367C35.7755 30.0287 35.7907 30.0202 35.8065 30.013C36.614 29.6434 37.1003 28.8011 37.0166 27.917C36.9959 27.6983 37.0546 27.4791 37.182 27.3C37.6965 26.5762 37.6965 25.6035 37.1819 24.8797C37.0546 24.7006 36.9959 24.4816 37.0166 24.2627C37.1003 23.3787 36.614 22.5363 35.8064 22.1667C35.6066 22.0752 35.4462 21.9148 35.3548 21.7151C34.9852 20.9075 34.1425 20.4213 33.2587 20.5049C33.0398 20.5258 32.8208 20.467 32.6417 20.3396C31.9179 19.8251 30.9452 19.825 30.2214 20.3396C30.0423 20.467 29.8227 20.5258 29.6045 20.5048C28.7193 20.4216 27.8779 20.9075 27.5084 21.715C27.417 21.9148 27.2566 22.0752 27.0567 22.1666C26.2492 22.5362 25.7629 23.3785 25.8466 24.2627C25.8673 24.4815 25.8086 24.7005 25.6812 24.8797C25.1667 25.6035 25.1667 26.5762 25.6812 27.2999C25.8086 27.479 25.8673 27.6981 25.8466 27.917C25.7629 28.8011 26.2492 29.6434 27.0567 30.013C27.0725 30.0202 27.0876 30.0286 27.1028 30.0366L26.8005 30.6703H1.62773C1.37687 30.6703 1.17273 30.4662 1.17273 30.2153V5.41289C1.17273 5.16203 1.3768 4.95789 1.62773 4.95789H38.3723C38.6231 4.95789 38.8273 5.16203 38.8273 5.41289V30.2153Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.3889 22.4453C29.38 22.4453 27.7456 24.0797 27.7456 26.0885C27.7456 28.0974 29.38 29.7318 31.3889 29.7318C33.3978 29.7318 35.0321 28.0973 35.0321 26.0885C35.0321 24.0796 33.3978 22.4453 31.3889 22.4453ZM31.3889 28.559C30.0266 28.559 28.9183 27.4507 28.9183 26.0884C28.9183 24.7262 30.0266 23.618 31.3889 23.618C32.7511 23.618 33.8594 24.7262 33.8594 26.0884C33.8594 27.4507 32.7511 28.559 31.3889 28.559Z",
                fill: "currentColor"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CertificateImg);


/***/ }),

/***/ 63755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37559);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26449);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45332);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75367);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);









var SearchForm = function(param) {
    var placeholder = param.placeholder, formStyle = param.formStyle, setPage = param.setPage;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useForm */ .cI)(), control = ref1.control, watch = ref1.watch, setValue = ref1.setValue;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var _type;
    var queryString = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .buildQueryString */ .Ie)({
        status: router.query.status || "",
        type: (_type = router.query.type) !== null && _type !== void 0 ? _type : ""
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isFirstRender = ref3[0], setIsFirstRender = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var timerId;
        // Use useEffect to set up a timer to make the API call after 3 seconds
        if (!isFirstRender && ((ref = watch("name")) === null || ref === void 0 ? void 0 : ref.length) >= 3) {
            timerId = setTimeout(function() {
                var ref;
                !isSubmitting && router.push("/courses?name=".concat((ref = watch("name")) !== null && ref !== void 0 ? ref : "").concat(queryString));
                setPage && setPage(9);
            }, 2000);
        }
        // Clean up the timer when the component unmounts or when the input value changes
        return function() {
            clearTimeout(timerId);
        };
    }, [
        watch("name"),
        isSubmitting
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsFirstRender(false);
    }, [
        setIsFirstRender
    ]);
    var handleReset = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.debounce)(function(e) {
        e.preventDefault();
        setIsFirstRender(false);
        setIsSubmitting(false);
        // Check if 'name' is empty and perform search immediately
        if (!watch("name")) {
            var ref;
            router.push("/courses?name=".concat((ref = watch("name")) !== null && ref !== void 0 ? ref : "").concat(queryString));
            setPage && setPage(9);
        }
    }, 500);
    var handleSubmit = function(e) {
        e.preventDefault();
        setIsSubmitting(true);
        setIsFirstRender(false);
        var ref;
        // Redirect to the search results page with the query as a query parameter
        router.push("/courses?name=".concat((ref = watch("name")) !== null && ref !== void 0 ? ref : "").concat(queryString));
        setPage && setPage(9);
    };
    /**
   * @description set lại value của name khi router query rỗng
   */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_5__.isEmpty)(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.name)) {
            setValue("name", "");
        }
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.name,
        setValue
    ]);
    var _name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        className: formStyle,
        onSubmit: handleSubmit,
        onChange: handleReset,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "submit",
                className: "flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    type: "search",
                    className: "text-primary"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .Controller */ .Qr, {
                control: control,
                name: "name",
                defaultValue: (_name = router.query.name) !== null && _name !== void 0 ? _name : "",
                render: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, field), {
                        type: "text",
                        placeholder: placeholder,
                        className: "placeholder-text-gray-1 h-6 w-full border-0 px-4 text-bw-1 focus:border-0 focus:outline-0 focus:ring-0"
                    }));
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchForm);


/***/ }),

/***/ 35267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(62270);
// EXTERNAL MODULE: ./src/components/mycourses/Search.tsx
var Search = __webpack_require__(63755);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(12691);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/profile/BreadCrumbMyprofile.tsx



var BreadcrumbProfile = function(param) {
    var tabs = param.tabs, currentPage = param.currentPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "breadcrumb",
        "aria-label": "breadcrumbs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "breadcrumb flex flex-row py-6 text-sm font-medium",
            children: tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: index !== tabs.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            tab.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: tab.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: currentPage === tab.title ? "text-sm text-bw-1" : "text-sm text-gray-1",
                                    children: tab.title
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tab.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(currentPage === tab.link ? "text-sm text-bw-1 " : "text-sm text-gray-1", " pr-1"),
                                children: " / "
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: tab.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-sm text-bw-1",
                            children: tab.title
                        })
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var BreadCrumbMyprofile = (BreadcrumbProfile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./src/components/base/button/SappButton.tsx
var SappButton = __webpack_require__(98971);
// EXTERNAL MODULE: ./src/components/layout/ExpandIcon/CertificateImg.tsx
var CertificateImg = __webpack_require__(83251);
// EXTERNAL MODULE: ./src/pages/api/profile/index.ts
var profile = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
// EXTERNAL MODULE: ./src/redux/hook.ts
var hook = __webpack_require__(34705);
// EXTERNAL MODULE: ./src/redux/slice/ConfirmDialog/ConfirmDialogThunk.ts
var ConfirmDialogThunk = __webpack_require__(55771);
// EXTERNAL MODULE: ./src/components/base/button/ButtonCancelSubmit.tsx
var ButtonCancelSubmit = __webpack_require__(20010);
;// CONCATENATED MODULE: ./src/components/profile/popupCertificate/CertificatePopup.tsx








/**
 * Hàm này tạo một modal component bằng React
 * @param open: boolean - biến xác định modal có được mở hay không
 * @param setOpen: function - hàm xác định modal có được mở hay không
 * @param children: ReactNode - biến chứa các phần tử con của modal
 * @param cancelButtonCaption: string - biến xác định nội dung của nút hủy
 * @param okButtonCaption: string - biến xác định nội dung của nút xác nhận
 * @param handleCancel: function - hàm xử lý khi người dùng nhấn nút hủy
 * @param handleSubmit: function - hàm xử lý khi người dùng nhấn nút xác nhận
 * @param disabled: boolean - biến xác định modal có bị vô hiệu hóa hay không
 * @param title: string - biến xác định tiêu đề của modal
 * @param showTitle: boolean - biến xác định modal có hiển thị tiêu đề hay không
 * @param customTitle: ReactNode - biến chứa phần tử tùy chỉnh cho tiêu đề
 * @param showFooter: boolean - biến xác định modal có hiển thị footer hay không
 * @param customFooter: ReactNode - biến chứa phần tử tùy chỉnh cho footer
 * @param confirmOnclose: boolean - biến xác định modal có yêu cầu xác nhận khi đóng hay không
 * @param width: number - biến xác định modal width
 */ var SappModalCerti = function(param) {
    var open = param.open, children = param.children, _cancelButtonCaption = param.cancelButtonCaption, cancelButtonCaption = _cancelButtonCaption === void 0 ? "Cancel" : _cancelButtonCaption, _okButtonCaption = param.okButtonCaption, okButtonCaption = _okButtonCaption === void 0 ? "Submit" : _okButtonCaption, okButtonClass = param.okButtonClass, cancelButtonClass = param.cancelButtonClass, _buttonSize = param.buttonSize, buttonSize = _buttonSize === void 0 ? "medium" : _buttonSize, handleCancel = param.handleCancel, handleSubmit = param.handleSubmit, disabled = param.disabled, title = param.title, customTitle = param.customTitle, _showHeader = param.showHeader, showHeader = _showHeader === void 0 ? true : _showHeader, customHeader = param.customHeader, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, customFooter = param.customFooter, confirmOnclose = param.confirmOnclose, _size = param.size, size = _size === void 0 ? "max-w-lg" : _size, _modelClassname = param.modelClassname, modelClassname = _modelClassname === void 0 ? "" : _modelClassname, _refClass = param.refClass, refClass = _refClass === void 0 ? "md:px-6 px-5 py-5 flex flex-col animate-jump-in relative transform overflow-hidden bg-white text-left shadow-xl transition-all" : _refClass, _childClass = param.childClass, childClass = _childClass === void 0 ? "" : _childClass, _parentChildClass = param.parentChildClass, parentChildClass = _parentChildClass === void 0 ? "" : _parentChildClass, _footerButtonClassName = param.footerButtonClassName, footerButtonClassName = _footerButtonClassName === void 0 ? "justify-center sm:justify-end flex gap-3" : _footerButtonClassName, _overlayClass = param.overlayClass, overlayClass = _overlayClass === void 0 ? "" : _overlayClass, color = param.color, _colorCancel = param.colorCancel, colorCancel = _colorCancel === void 0 ? "text" : _colorCancel, _position = param.position, position = _position === void 0 ? "start" : _position, _fullWidthBtn = param.fullWidthBtn, fullWidthBtn = _fullWidthBtn === void 0 ? false : _fullWidthBtn, _isFullScreen = param.isFullScreen, isFullScreen = _isFullScreen === void 0 ? false : _isFullScreen, _isContentFull = param.isContentFull, isContentFull = _isContentFull === void 0 ? true : _isContentFull, _isInner = param.isInner, isInner = _isInner === void 0 ? false : _isInner, _isBordered = param.isBordered, isBordered = _isBordered === void 0 ? false : _isBordered, _closeAfterSubmit = param.closeAfterSubmit, closeAfterSubmit = _closeAfterSubmit === void 0 ? true : _closeAfterSubmit, _showOkButton = param.showOkButton, showOkButton = _showOkButton === void 0 ? true : _showOkButton, _showCancelButton = param.showCancelButton, showCancelButton = _showCancelButton === void 0 ? true : _showCancelButton, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? "z-[1000]" : _zIndex, _scrollbale = param.scrollbale, scrollbale = _scrollbale === void 0 ? true : _scrollbale, footerClassName = param.footerClassName, externalLoading = param.externalLoading;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var confirmDialogRef = (0,react.useRef)(null);
    var confirmDialogOverLayRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!isInner) {
            if (open) {
                var scrollBarWidth = window.innerWidth - document.body.clientWidth;
                setTimeout(function() {
                    document.body.style.paddingRight = scrollBarWidth + "px";
                    document.body.classList.add("overflow-hidden");
                });
            } else {
                var customModal = document.querySelectorAll(".sapp-custom-modal:not(.sapp-custom-modal-inner)");
                if (!(customModal === null || customModal === void 0 ? void 0 : customModal.length)) {
                    document.body.style.removeProperty("padding-right");
                    document.body.classList.remove("overflow-hidden");
                }
            }
        }
    }, [
        open
    ]);
    /**
   * Hàm này xử lý khi người dùng nhấn nút xác nhận
   * @return void
   */ var onOk = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (handleSubmit) {}
                        if (!(handleSubmit && handleSubmit.constructor.name === "AsyncFunction")) return [
                            3,
                            6
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            handleSubmit()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        if (closeAfterSubmit) {
                            handleClose();
                        }
                        return [
                            2
                        ];
                    case 6:
                        if (handleSubmit) {
                            handleSubmit();
                        }
                        _state.label = 7;
                    case 7:
                        if (closeAfterSubmit) {
                            handleClose();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onOk() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Hàm này xử lý khi người dùng nhấn nút hủy
   * @return void
   */ var onCancel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var callHandleCancel;
            return (0,tslib_es6.__generator)(this, function(_state) {
                callHandleCancel = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(handleCancel && handleCancel.constructor.name === "AsyncFunction")) return [
                                        3,
                                        2
                                    ];
                                    setLoading(true);
                                    return [
                                        4,
                                        handleCancel()
                                    ];
                                case 1:
                                    _state.sent();
                                    setLoading(false);
                                    handleClose();
                                    return [
                                        2
                                    ];
                                case 2:
                                    if (handleCancel) {
                                        handleClose();
                                    }
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function callHandleCancel() {
                        return _ref.apply(this, arguments);
                    };
                }();
                // Nếu confirmOnclose là true, thì mở một hộp thoại xác nhận
                if (confirmOnclose) {
                    dispatch(ConfirmDialogThunk/* default.open */.Z.open({
                        // Nội dung của hộp thoại xác nhận
                        message: "Bạn c\xf3 chắc chắn muốn hủy kh\xf4ng?",
                        // Hàm thực thi khi người dùng xác nhận hành động
                        onConfirm: callHandleCancel
                    }));
                } else {
                    // Nếu confirmOnclose là false, thì không cần xác nhận
                    // Gọi hàm callHandleCancel
                    callHandleCancel();
                }
                return [
                    2
                ];
            });
        });
        return function onCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        if (confirmDialogRef.current) {
            confirmDialogRef.current.classList.add("animate-jump-out");
            confirmDialogRef.current.classList.add("pointer-events-none");
        }
        if (confirmDialogOverLayRef.current) {
            confirmDialogOverLayRef.current.classList.add("animate-fade-out-overlay");
            confirmDialogOverLayRef.current.classList.add("pointer-events-none");
        }
        setTimeout(function() {
            handleCancel && handleCancel();
        }, 50);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: open && // add an onClick handler to the outer div to close the popup when clicking outside
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sapp-custom-modal ".concat(isInner ? "sapp-custom-modal-inner absolute max-h-full" : "fixed max-h-screen", " inset-0 flex w-full items-center justify-center ").concat(zIndex, " ").concat(modelClassname),
                role: "dialog",
                "aria-modal": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: confirmDialogOverLayRef,
                        onClick: function() {
                            if (externalLoading !== undefined) {
                                if (externalLoading) {
                                    return;
                                }
                            }
                            if (loading) {
                                return;
                            }
                            onCancel();
                        },
                        className: "".concat(isInner ? "absolute" : "fixed", " inset-0  animate-fade-in-overlay bg-black opacity-80 transition-opacity ").concat(overlayClass)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(isFullScreen || "".concat(size, " p-4 xl:py-10"), "  inset-0 flex h-full w-full justify-center text-center items-").concat(position),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: confirmDialogRef,
                            className: "max-h-full max-w-full \n                  ".concat(isContentFull ? "w-full" : "w-fit", "\n                  ").concat(refClass),
                            children: [
                                showHeader && (customHeader || /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative bg-white pb-5 md:pb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                customTitle || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xl font-bold text-bw-1",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-auto cursor-pointer",
                                                    onClick: onCancel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                                        className: "transform stroke-bw-1 transition-all duration-300 ease-in-out group-hover:stroke-primary"
                                                    })
                                                })
                                            ]
                                        }),
                                        isBordered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 bottom-0 -z-10 -mx-6 h-[1px] border-b border-gray-2"
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(parentChildClass, " ").concat(scrollbale && "-mr-4.5 flex-1 snap-y overflow-y-scroll bg-white"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(childClass),
                                        children: children
                                    })
                                }),
                                showFooter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative pt-5 md:pt-5 ".concat(footerClassName),
                                    children: [
                                        isBordered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute left-0 right-0 top-0 -mx-6 border-b border-gray-2"
                                        }),
                                        customFooter || /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancelSubmit/* default */.Z, {
                                            className: footerButtonClassName,
                                            color: color,
                                            colorCancel: colorCancel,
                                            showOkButton: showOkButton,
                                            showCancelButton: showCancelButton,
                                            submit: {
                                                title: okButtonCaption,
                                                size: buttonSize,
                                                loading: externalLoading != undefined ? externalLoading : loading,
                                                disabled: disabled,
                                                onClick: onOk,
                                                full: fullWidthBtn,
                                                className: okButtonClass
                                            },
                                            cancel: {
                                                title: cancelButtonCaption,
                                                size: buttonSize,
                                                onClick: onCancel,
                                                loading: externalLoading != undefined ? externalLoading : loading,
                                                full: fullWidthBtn,
                                                className: cancelButtonClass
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CertificatePopup = (SappModalCerti);

;// CONCATENATED MODULE: ./src/components/profile/popupCertificate/index.tsx




var PopUpCertificate = function(param) {
    var openPreview = param.openPreview, setOpenModal = param.setOpenModal, data = param.data, message = param.message, onClose = param.onClose, _confirmOnClose = param.confirmOnClose, confirmOnClose = _confirmOnClose === void 0 ? true : _confirmOnClose, userDetail = param.userDetail;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var handleOnClose = function() {
        onClose();
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificatePopup, {
        open: openPreview,
        setOpen: setOpenModal,
        showHeader: false,
        showFooter: false,
        title: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.course) === null || ref === void 0 ? void 0 : ref.name) !== null && ref2 !== void 0 ? ref2 : "Preview Certification",
        size: "max-w-[1200px] max-h-[1200px] w-fit h-fit",
        footerButtonClassName: "flex flex-col-reverse gap-6",
        childClass: "flex flex-col justify-center items-center",
        parentChildClass: "",
        position: "center",
        buttonSize: "extra",
        isContentFull: true,
        scrollbale: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full justify-between border-b border-solid border-gray-3 pb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " flex w-full pr-4 font-sans text-xl font-medium leading-6.2 text-bw-1",
                            children: data === null || data === void 0 ? void 0 : (ref1 = data.course) === null || ref1 === void 0 ? void 0 : ref1.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: handleOnClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIconPreview */.ce, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center pt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: data === null || data === void 0 ? void 0 : data.certificate_url,
                        className: "h-auto w-full"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var popupCertificate = (PopUpCertificate);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(25925);
;// CONCATENATED MODULE: ./src/components/profile/TabLayout.tsx





var TabLayout = function(_param) {
    var children = _param.children, title = _param.title, headerButtons = _param.headerButtons, onScroll = _param.onScroll, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "title",
        "headerButtons",
        "onScroll"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "sticky top-0 flex items-center justify-between border-b border-gray-3 bg-white"
            }, props), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-6 pb-5 pt-6 text-xl font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-6",
                        children: headerButtons
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onScroll: onScroll,
                className: "h-[calc(604px-70px)] overflow-y-auto",
                children: children
            })
        ]
    });
};
/* harmony default export */ var profile_TabLayout = (TabLayout);

;// CONCATENATED MODULE: ./src/components/profile/Certificate.tsx









var Certificate = function(param) {
    var onOpenTab = param.onOpenTab;
    var ref = (0,react.useState)([]), certificateData = ref[0], setCertificateData = ref[1];
    var ref1 = (0,react.useState)("0"), totalCertificateData = ref1[0], setTotalCertificateData = ref1[1];
    var ref2 = (0,react.useState)(false), modalOpen = ref2[0], setOpenModal = ref2[1];
    var ref3 = (0,react.useState)(""), userDetail = ref3[0], setUserDetail = ref3[1];
    var fetchChapterDetail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, certificate, totalCertificate, userDetail, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            profile/* AuthAPI.getCertificate */.u.getCertificate(1, 10)
                        ];
                    case 1:
                        res = _state.sent();
                        certificate = res.data.certificates;
                        totalCertificate = res.data.meta.total_records;
                        userDetail = res.username;
                        setTotalCertificateData(totalCertificate);
                        setCertificateData(certificate);
                        setUserDetail(userDetail);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchChapterDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useLayoutEffect)(function() {
        fetchChapterDetail();
    }, []);
    var ref4 = (0,react.useState)(), certificateDataPopup = ref4[0], setCertificateDataPopup = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
                title: "Certificates (".concat(totalCertificateData, ")"),
                headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                    onClick: onOpenTab,
                    size: "medium",
                    title: "Back",
                    color: "textUnderline",
                    className: "-mr-8 block min-w-[120px] text-base lg:hidden"
                }),
                children: certificateData.map(function(certificate) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "group relative flex min-h-[88px] w-full cursor-pointer flex-row items-start gap-2 self-center border-b border-gray-3 px-6 pt-5 hover:bg-secondary hover:text-primary",
                            onClick: function() {
                                return window.open("".concat("https://lms-pro.sapp.edu.vn", "/certificates/").concat(certificate === null || certificate === void 0 ? void 0 : certificate.id), "_blank");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " border-bottom mb-5 flex flex-row items-start justify-center border bg-gray-4 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "h-[48px] w-[80px] border border-solid px-5 py-1 hover:text-primary group-hover:border-active group-hover:bg-secondary ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificateImg/* default */.Z, {
                                            className: "border-none text-gray-1 group-hover:text-primary"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative flex w-full cursor-pointer flex-col items-start gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-active text-base font-medium leading-[24px] hover:text-primary",
                                            children: certificate === null || certificate === void 0 ? void 0 : (ref = certificate.course) === null || ref === void 0 ? void 0 : ref.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cursor-pointer text-[13px] leading-[16px] text-gray-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    " Grade Achieved: ",
                                                    certificate === null || certificate === void 0 ? void 0 : certificate.pass_point,
                                                    " %"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, certificate === null || certificate === void 0 ? void 0 : certificate.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popupCertificate, {
                openPreview: modalOpen,
                setOpenModal: setOpenModal,
                data: certificateDataPopup,
                message: "",
                onClose: function() {
                    setCertificateDataPopup(null);
                    setOpenModal(false);
                },
                userDetail: userDetail
            })
        ]
    });
};
/* harmony default export */ var profile_Certificate = (Certificate);

// EXTERNAL MODULE: ./src/components/base/textfield/HookFormTextField.tsx
var HookFormTextField = __webpack_require__(70745);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(35447);
// EXTERNAL MODULE: ./src/utils/constants/ValidateRegex.ts
var ValidateRegex = __webpack_require__(17332);
// EXTERNAL MODULE: ./src/utils/helpers/ValidateMessage.ts
var ValidateMessage = __webpack_require__(62179);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(10103);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(5137);
// EXTERNAL MODULE: ./src/services/en.exceptions.json
var en_exceptions = __webpack_require__(20959);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(72760);
// EXTERNAL MODULE: ./src/components/auth/Countdown.tsx
var Countdown = __webpack_require__(22338);
// EXTERNAL MODULE: ./src/components/base/button/ButtonText.tsx
var ButtonText = __webpack_require__(40392);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalV2.tsx
var SappModalV2 = __webpack_require__(89186);
// EXTERNAL MODULE: ./src/components/base/textfield/SAPPTextFiled.tsx
var SAPPTextFiled = __webpack_require__(41012);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(72808);
;// CONCATENATED MODULE: ./src/components/profile/PasswordProfile.tsx













var PasswordProfile = function(param) {
    var open = param.open, reset = param.reset, setOpen = param.setOpen, getValues = param.getValues;
    var ref = (0,react.useState)(Array(6).join(".").split(".")), code = ref[0], setCode = ref[1];
    var ref1 = (0,react.useState)(false), canResend = ref1[0], setCanResend = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Countdown/* default */.Z)(5), 3), timeCountDown = ref2[0], setTimeCountDown = ref2[1], time = ref2[2];
    var ref3 = (0,react.useState)(285), timeCountDownResent = ref3[0], settimeCountDownResent = ref3[1];
    var ref4 = (0,react.useState)(""), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var inputRefs = Array(6).fill(0).map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    });
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    /**
   * @description mở popup set lại countdown và message error
   */ (0,react.useEffect)(function() {
        if (open) {
            setTimeCountDown(5);
            setErrorMessage("");
        }
    }, [
        open
    ]);
    /**
   * @description Handle countdown timeout
   */ (0,react.useEffect)(function() {
        if (time < timeCountDownResent && canResend === false) {
            setCanResend(true);
        }
        if (time <= 0) {
            setErrorMessage("OTP expired. Please generate a new OTP and try again!");
            setCanResend(true);
        }
    }, [
        timeCountDown
    ]);
    /**
   * @description Handling when entering code into the input cell
   */ var onEnterDigit = function(index, event) {
        var value = event.target.value;
        // Validate input data, pass if data is single number or empty string
        if (Number.isNaN(parseInt(value)) && value != "" || value.length > 1) return event.preventDefault();
        // Focus to next input cell
        if (index < 5 && value) {
            var ref;
            (ref = inputRefs[index + 1].current) === null || ref === void 0 ? void 0 : ref.focus();
        }
        // Update the code
        var newCode = (0,_to_consumable_array/* default */.Z)(code);
        newCode[index] = value;
        setCode(newCode);
    };
    /**
   * @description chức năng paste OTP
   */ var handlePaste = function(index, e) {
        var _newOtp;
        e.preventDefault() // Ngăn chặn hành động paste mặc định
        ;
        var pasted = e.clipboardData.getData("text/plain").replace(/\n/g, "").replace(/\r/g, "").split(" ").slice(0, 6);
        // Update the OTP array
        var newOtp = (0,_to_consumable_array/* default */.Z)(code);
        (_newOtp = newOtp).splice.apply(_newOtp, [
            index,
            pasted.length
        ].concat((0,_to_consumable_array/* default */.Z)(pasted)));
        setCode(newOtp === null || newOtp === void 0 ? void 0 : newOtp.filter(function(value) {
            return value !== "";
        }));
    };
    /**
   * @description function verify code
   */ var verifyCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            profile/* AuthAPI.verifyOTPPassword */.u.verifyOTPPassword(getValues("password"), getValues("newPassword"), code === null || code === void 0 ? void 0 : code.join(""))
                        ];
                    case 2:
                        _state.sent();
                        reset();
                        setOpen(false);
                        setCode([
                            "",
                            "",
                            "",
                            "",
                            "",
                            ""
                        ]);
                        dist/* default.success */.ZP.success("Change Password Successfully!");
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function verifyCode() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * @description Handle on click resend button
   */ var onResendCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            profile/* AuthAPI.changeUserPassword */.u.changeUserPassword(getValues("password"))
                        ];
                    case 1:
                        _state.sent();
                        setErrorMessage("");
                        setCanResend(false);
                        settimeCountDownResent(function() {
                            if (time <= 0) {
                                setTimeCountDown(5);
                                return 285;
                            }
                            return time - 15;
                        });
                        setCode(Array(6).join(".").split("."));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onResendCode() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SappModalV2/* default */.Z, {
        title: undefined,
        open: open,
        handleCancel: function() {
            return setOpen(false);
        },
        onOk: function() {},
        showFooter: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2 text-4xl font-semibold text-bw-1",
                    children: "Change Password"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mb-10 text-medium-sm text-gray-1",
                    children: "Enter your 6-digit code that you received on your email."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2 mt-12 grid grid-cols-6 grid-rows-1 gap-3",
                    children: code === null || code === void 0 ? void 0 : code.map(function(otp, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(SAPPTextFiled/* default */.Z, {
                            inputRef: inputRefs[index],
                            type: "text",
                            value: otp,
                            onChange: function(event) {
                                return onEnterDigit(index, event);
                            },
                            inputClassName: "text-center h-[67px] w-[67px] ".concat(errorMessage ? "border-state-error" : "border-gray-2", " pt-5.25 pb-5 px-0"),
                            onPaste: function(e) {
                                return (code === null || code === void 0 ? void 0 : code.every(function(data) {
                                    return data === "";
                                })) && handlePaste(index, e);
                            }
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-8 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-medium-sm text-state-error",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "min-w-fit text-right text-medium-sm ".concat(timeCountDown === "00:00" ? "text-state-error" : "text-bw-1"),
                            children: timeCountDown
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                    title: "Verify Code",
                    full: true,
                    className: "mb-5 h-12.5 !font-semibold",
                    size: "lager",
                    loading: loading,
                    onClick: verifyCode,
                    disabled: code.some(function(e) {
                        return e === "";
                    }) || time <= 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText/* default */.Z, {
                    title: "Resend Code",
                    full: true,
                    disabled: !canResend,
                    onClick: onResendCode,
                    className: "pb-3.25 pt-3 no-underline",
                    size: "medium",
                    loading: loading
                })
            ]
        })
    });
};
/* harmony default export */ var profile_PasswordProfile = (PasswordProfile);

;// CONCATENATED MODULE: ./src/components/profile/ChangePassword.tsx

















var ChangePassword = function(param) {
    var onOpenTab = param.onOpenTab;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    /**
   * @description validate password
   */ var validationSchema = lib.z.object({
        password: lib.z.string({
            required_error: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).trim().min(1, {
            message: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).min(8, {
            message: (0,ValidateMessage/* VALIDATE_MIN_LENGTH_PASSWORD */.UE)("Password", 8, 1, 1)
        }).regex(ValidateRegex/* VALIDATE_PASSWORD */.T, ValidateMessage/* VALIDATE_PASSWORD_REGEX_MSG */.Ob),
        newPassword: lib.z.string({
            required_error: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).trim().min(1, {
            message: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).min(8, {
            message: (0,ValidateMessage/* VALIDATE_MIN_LENGTH_PASSWORD */.UE)("Password", 8, 1, 1)
        }).regex(ValidateRegex/* VALIDATE_PASSWORD */.T, ValidateMessage/* VALIDATE_PASSWORD_REGEX_MSG */.Ob),
        confirmPassword: lib.z.string({
            required_error: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).trim().min(1, {
            message: ValidateMessage/* VALIDATE_REQUIRED */.yK
        }).min(8, {
            message: (0,ValidateMessage/* VALIDATE_MIN_LENGTH_PASSWORD */.UE)("Password", 8, 1, 1)
        }).regex(ValidateRegex/* VALIDATE_PASSWORD */.T, ValidateMessage/* VALIDATE_PASSWORD_REGEX_MSG */.Ob)
    }).refine(function(data) {
        return data.newPassword === data.confirmPassword;
    }, {
        message: "Passwords don't match",
        path: [
            "confirmPassword"
        ]
    });
    /**
   * @description sử dụng useForm
   */ var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(validationSchema),
        mode: "onSubmit"
    }), control = ref1.control, handleSubmit = ref1.handleSubmit, reset = ref1.reset, getValues = ref1.getValues, watch = ref1.watch, setError = ref1.setError;
    /**
   * @description state này dùng để mở popup khi submit thành công mật khẩu hiện tại
   */ var ref2 = (0,react.useState)(false), openPopup = ref2[0], setOpenPopup = ref2[1];
    /**
   * @description call API submit mật khẩu hiện tại
   */ var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var error, ref, ref1, ref2, errorCode, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            profile/* AuthAPI.changeUserPassword */.u.changeUserPassword(data.password)
                        ];
                    case 2:
                        _state.sent();
                        setOpenPopup(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        errorCode = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.code;
                        errorMessage = en_exceptions.find(function(exception) {
                            return exception.code === errorCode;
                        });
                        setError("password", {
                            message: (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message) || ""
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: "block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
                        title: "Change Password",
                        headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                                    onClick: onOpenTab,
                                    size: "medium",
                                    title: "Back",
                                    color: "textUnderline",
                                    className: "block min-w-[120px] pr-0 text-base lg:hidden"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancelSubmit/* default */.Z, {
                                    className: "flex",
                                    cancel: {
                                        title: "",
                                        onClick: function() {},
                                        size: "medium"
                                    },
                                    submit: {
                                        title: "Save",
                                        size: "medium",
                                        className: "min-w-fit px-0 text-sm w-30",
                                        type: "submit",
                                        disabled: loading || (0,lodash.isEmpty)(watch("confirmPassword")) || (0,lodash.isEmpty)(watch("newPassword")) || (0,lodash.isEmpty)(watch("password"))
                                    }
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 grid grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center text-base text-gray-1",
                                            children: "Current Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                                control: control,
                                                name: "password",
                                                type: "password"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 grid grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center text-base text-gray-1",
                                            children: "New Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                                control: control,
                                                name: "newPassword",
                                                type: "password"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 grid grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center text-base text-gray-1",
                                            children: "Confirm New Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                                control: control,
                                                name: "confirmPassword",
                                                type: "password"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_PasswordProfile, {
                open: openPopup,
                setOpen: setOpenPopup,
                reset: reset,
                getValues: getValues
            })
        ]
    });
};
/* harmony default export */ var profile_ChangePassword = (ChangePassword);

// EXTERNAL MODULE: ./src/utils/helpers/index.ts
var helpers = __webpack_require__(71836);
;// CONCATENATED MODULE: ./src/components/base/deviceItem/DeviceItem.tsx




var DeviceItem = function(param) {
    var data = param.data;
    var ref;
    var chooseLogo = (0,react.useMemo)(function() {
        var ref;
        if (data === null || data === void 0 ? void 0 : (ref = data.user_agent) === null || ref === void 0 ? void 0 : ref.osName) {
            switch(data.user_agent.osName){
                case "Windows":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WinDowLogo */.MR, {});
                case "Mac OS":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AppleLogo */.uZ, {});
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PhoneLogo */.AI, {});
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.user_agent) === null || ref === void 0 ? void 0 : ref.osName
    ]);
    var formattedDate = (0,react.useMemo)(function() {
        if (data === null || data === void 0 ? void 0 : data.created_at) {
            return (0,helpers/* calculateTimeAgo */.KI)(data.created_at);
        }
        return null;
    }, [
        data.created_at
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sapp-hover-device-item flex items-center gap-4 px-6 py-5 hover:bg-secondary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sapp-logo box-border flex h-12 w-12 items-center justify-center border border-gray-1 bg-gray-4",
                children: chooseLogo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-medium text-bw-1",
                                children: "".concat(data.user_agent.browserName, " ").concat(data.user_agent.browserVersion, " (").concat(data.user_agent.osName, ")")
                            }),
                            data.is_current && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-fit bg-blue-50 px-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xsm text-state-info",
                                    children: "This Browser"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xsm text-gray-1",
                                children: formattedDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[4px] w-[4px] rounded-full bg-gray-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xsm text-gray-1",
                                children: data.ip
                            }),
                            data.location && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[4px] w-[4px] rounded-full bg-gray-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: data.location || ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var deviceItem_DeviceItem = (DeviceItem);

// EXTERNAL MODULE: ./src/constants/lang.ts
var lang = __webpack_require__(66190);
// EXTERNAL MODULE: ./src/redux/services/User/user.ts + 1 modules
var user = __webpack_require__(39421);
;// CONCATENATED MODULE: ./src/components/profile/Devices.tsx










var Devices = function(param) {
    var onOpenTab = param.onOpenTab;
    var ref = (0,react.useState)(), listDevices = ref[0], setListDevices = ref[1];
    var getListDevices = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            user/* default.getListDevices */.Z.getListDevices()
                        ];
                    case 1:
                        res = _state.sent();
                        setListDevices(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function getListDevices() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getListDevices();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
        title: "Browsers (".concat((listDevices === null || listDevices === void 0 ? void 0 : listDevices.length) || 0, ")"),
        headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
            onClick: onOpenTab,
            size: "medium",
            title: "Back",
            color: "textUnderline",
            className: "block pr-0 text-base lg:hidden"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                listDevices === null || listDevices === void 0 ? void 0 : listDevices.map(function(e) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(deviceItem_DeviceItem, {
                            data: e
                        })
                    }, e.id);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-6 mb-6 mt-3 flex items-center gap-3 bg-gray-4 p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SecurityIcon */.J8, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-sm text-bw-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "Maximum limit of 3 browsers: Please contact support team",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#",
                                        className: "text-state-info underline",
                                        children: lang/* MY_COURSES.hotline */.EQ.hotline
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " ",
                                        "to remove one before accessing your account on another."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var profile_Devices = (Devices);

// EXTERNAL MODULE: ./src/components/base/pagination/PaginationSAPP.tsx + 2 modules
var PaginationSAPP = __webpack_require__(47394);
// EXTERNAL MODULE: ./src/components/base/SappTable.tsx
var SappTable = __webpack_require__(78959);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 10 modules
var skeleton = __webpack_require__(44755);
;// CONCATENATED MODULE: ./src/components/common/LoadingRow.tsx


var LoadingRow = function(param) {
    var headers = param.headers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
        children: headers.map(function(header) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                    size: "default",
                    active: true,
                    className: "m-0.5"
                })
            }, header);
        })
    });
};
/* harmony default export */ var common_LoadingRow = (LoadingRow);

// EXTERNAL MODULE: ./src/pages/api/queryKey.ts
var queryKey = __webpack_require__(8590);
// EXTERNAL MODULE: ./src/pages/api/user/index.ts
var api_user = __webpack_require__(59211);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(57368);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(79555);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/components/profile/ExamInformation/ExamEditDrawer.tsx + 2 modules
var ExamEditDrawer = __webpack_require__(22093);
// EXTERNAL MODULE: ./src/components/base/clickoutside/HookClick.tsx
var HookClick = __webpack_require__(87248);
// EXTERNAL MODULE: ./src/components/icons/index.tsx
var components_icons = __webpack_require__(26449);
;// CONCATENATED MODULE: ./src/components/profile/ExamInformation/ExamInfoActionCell.tsx





var ExamInfoActionCell = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var wrapperRef = (0,react.useRef)(null);
    (0,HookClick/* default */.Z)({
        ref: wrapperRef,
        callback: function() {
            return setOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "containers",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cursor-pointer ".concat(open ? "active" : ""),
                onClick: function() {
                    return setOpen(!open);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_icons/* default */.ZP, {
                    type: "pencil"
                })
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("menu menu-sub menu-sub-dropdown absolute right-full top-0 z-50 w-36 rounded-md bg-white p-2 shadow-notify"),
                children: children
            })
        ]
    });
};
/* harmony default export */ var ExamInformation_ExamInfoActionCell = (ExamInfoActionCell);

// EXTERNAL MODULE: ./src/common/Tooltip.tsx
var Tooltip = __webpack_require__(45028);
;// CONCATENATED MODULE: ./src/components/profile/ExamInformation/ExamInfoTab.tsx















var commonHeaderCellStyle = "text-left text-medium-sm text-gray-1 font-semibold pb-3";
var commonDataCellStyle = "col text-start py-5 pr-6 whitespace-nowrap";
var headers = [
    "Course",
    "Class Code",
    "Program",
    "Subject",
    "Duration",
    "Scheduled Exam Date", 
].map(function(label) {
    return {
        label: label,
        className: commonHeaderCellStyle
    };
});
var ExamInfoTab = function(param) {
    var onBack = param.onBack;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isDrawerOpen = ref3[0], setIsDrawerOpen = ref3[1];
    var ref4 = (0,react.useState)(), currentRow = ref4[0], setCurrentRow = ref4[1];
    var ref5 = (0,react.useState)(1), pageIndex = ref5[0], setPageIndex = ref5[1];
    var ref6 = (0,react.useState)(10), pageSize = ref6[0], setPageSize = ref6[1];
    /**
   * @description sử dụng react-query để lấy data
   */ var ref7 = (0,es.useQuery)({
        queryKey: [
            queryKey/* UserKey.ExamList */.BN.ExamList,
            pageIndex,
            pageSize
        ],
        queryFn: function() {
            return api_user/* UserApi.getExamination */.W.getExamination(pageIndex || 1, pageSize);
        },
        select: function(data) {
            return data.data.data;
        },
        staleTime: 0
    }), data = ref7.data, isLoading = ref7.isLoading, isFetching = ref7.isFetching, isSuccess = ref7.isSuccess, refetch = ref7.refetch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
                title: "Exam Information",
                headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                    onClick: onBack,
                    size: "medium",
                    title: "Back",
                    color: "textUnderline",
                    className: "block min-w-[120px] pr-0 text-base lg:hidden",
                    loading: isLoading || isFetching
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mx-auto my-0 mb-6 max-w-xxl bg-white px-8 pb-3 pt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SappTable/* default */.Z, {
                            headers: headers,
                            hasCheck: false,
                            isCheckedAll: false,
                            classTable: "w-full",
                            children: isLoading || isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: headers.map(function(header, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadingRow, {
                                        headers: headers
                                    }, header.label);
                                })
                            }) : isSuccess && (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.map(function(row, index) {
                                var ref, ref1;
                                var _name, _name1, _code, _code1, _name2, _name3, _name4, ref2, _id;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: (_name = row.class.course.name) !== null && _name !== void 0 ? _name : "-",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ellipsis-text",
                                                    children: (_name1 = row.class.course.name) !== null && _name1 !== void 0 ? _name1 : "-"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: (_code = row.class.code) !== null && _code !== void 0 ? _code : "-",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ellipsis-text",
                                                    children: (_code1 = row.class.code) !== null && _code1 !== void 0 ? _code1 : "-"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle),
                                            children: (_name2 = row.class.course.course_categories[0].name) !== null && _name2 !== void 0 ? _name2 : "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                title: (_name3 = row.class.course.subject.name) !== null && _name3 !== void 0 ? _name3 : "-",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ellipsis-text ",
                                                    children: (_name4 = row.class.course.subject.name) !== null && _name4 !== void 0 ? _name4 : "-"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle),
                                            children: [
                                                row.started_at && dayjs_min_default()(row.started_at).format("DD/MM/YYYY"),
                                                " ",
                                                "-",
                                                " ",
                                                row.finished_at && dayjs_min_default()(row.finished_at).format("DD/MM/YYYY")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle, "min-w-36"),
                                            children: (ref2 = row === null || row === void 0 ? void 0 : (ref = row.examination_subject) === null || ref === void 0 ? void 0 : (ref1 = ref.examination) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: (0,clsx/* default */.Z)(commonDataCellStyle, "sticky -right-4 bg-white"),
                                            children: !(row === null || row === void 0 ? void 0 : row.is_final_examination_subject) && (row === null || row === void 0 ? void 0 : row.remaining_changes) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamInformation_ExamInfoActionCell, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "cursor-pointer rounded-md p-1 pl-2 transition-colors hover:bg-primary-light hover:text-primary",
                                                    onClick: function() {
                                                        setIsDrawerOpen(true);
                                                        setCurrentRow(row);
                                                    },
                                                    children: "Edit"
                                                })
                                            })
                                        })
                                    ]
                                }, (_id = row.id) !== null && _id !== void 0 ? _id : index);
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationSAPP/* default */.Z, {
                            currentPage: data === null || data === void 0 ? void 0 : data.metadata.page_index,
                            pageSize: data === null || data === void 0 ? void 0 : (ref1 = data.metadata) === null || ref1 === void 0 ? void 0 : ref1.page_size,
                            totalItems: data === null || data === void 0 ? void 0 : (ref2 = data.metadata) === null || ref2 === void 0 ? void 0 : ref2.total_records,
                            setCurrentPage: setPageIndex,
                            setPageSize: setPageSize,
                            type: "table",
                            classname: "mt-3"
                        })
                    ]
                })
            }),
            currentRow && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamEditDrawer/* default */.Z, {
                isOpen: isDrawerOpen,
                setIsOpen: setIsDrawerOpen,
                classId: currentRow.class.id,
                onSuccess: function() {
                    refetch();
                },
                currentValue: currentRow.examination_subject_id,
                remainingChanges: currentRow.remaining_changes
            })
        ]
    });
};
/* harmony default export */ var ExamInformation_ExamInfoTab = (ExamInfoTab);

// EXTERNAL MODULE: ./node_modules/date-fns/formatDistanceToNow.mjs + 10 modules
var formatDistanceToNow = __webpack_require__(28679);
// EXTERNAL MODULE: ./node_modules/date-fns/format.mjs + 17 modules
var format = __webpack_require__(39866);
;// CONCATENATED MODULE: ./src/components/base/historyItem/HistoryItem.tsx


var HistoryItem = function(param) {
    var data = param.data;
    var loginTime = new Date(data.updated_at);
    var currentTime = new Date();
    var timeDifference = currentTime.getTime() - loginTime.getTime();
    var formattedTime;
    if (timeDifference < 24 * 60 * 60 * 1000) {
        formattedTime = (0,formatDistanceToNow/* formatDistanceToNow */.Q)(loginTime, {
            addSuffix: true
        });
    } else {
        formattedTime = (0,format/* format */.WU)(loginTime, "HH:mm:ss dd/MM/yyyy");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " sapp-hover-device-item gap-4 px-6 py-5 hover:bg-secondary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-base font-medium text-bw-1",
                    children: data.ip
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xsm text-gray-1",
                        children: formattedTime
                    }),
                    data.location && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[4px] w-[4px] rounded-full bg-gray-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: data.location || ""
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var historyItem_HistoryItem = (HistoryItem);

// EXTERNAL MODULE: ./src/redux/slice/User/User.tsx
var User = __webpack_require__(85195);
;// CONCATENATED MODULE: ./src/components/profile/LoginHistory.tsx







var LoginHistory = function(param) {
    var onOpenTab = param.onOpenTab;
    var ref, ref1;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var ref2 = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3), loginHistory = ref2.loginHistory, loadHistory = ref2.loadHistory;
    var ref3 = (0,react.useState)(1), pageIndex = ref3[0], setPageIndex = ref3[1];
    var ref4 = (0,react.useState)(10), pageSize = ref4[0], setPageSize = ref4[1];
    (0,react.useEffect)(function() {
        dispatch((0,User/* getLoginHistory */.oY)({
            page_index: pageIndex,
            page_size: pageSize,
            type: "login"
        }));
    }, []);
    var handleLoadMoreHistory = function() {
        if (!loadHistory) {
            if (pageIndex < loginHistory.meta.total_pages) {
                setPageIndex(function(prev) {
                    dispatch((0,User/* loadMoreLoginHistory */.Pe)({
                        page_index: prev + 1,
                        page_size: pageSize
                    }));
                    return prev + 1;
                });
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
        title: "Login History (".concat((loginHistory === null || loginHistory === void 0 ? void 0 : (ref = loginHistory.meta) === null || ref === void 0 ? void 0 : ref.total_records) || 0, ")"),
        headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
            onClick: onOpenTab,
            size: "medium",
            title: "Back",
            color: "textUnderline",
            className: "-mr-8 block min-w-[120px] text-base lg:hidden"
        }),
        onScroll: function(e) {
            var target = e.target;
            if (target.scrollTop + target.offsetHeight >= target.scrollHeight) {
                handleLoadMoreHistory();
            }
        },
        children: loginHistory === null || loginHistory === void 0 ? void 0 : (ref1 = loginHistory.userActivities) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(historyItem_HistoryItem, {
                    data: e
                })
            }, e.id);
        })
    });
};
/* harmony default export */ var profile_LoginHistory = (LoginHistory);

// EXTERNAL MODULE: ./src/components/base/SappDrawer.tsx
var SappDrawer = __webpack_require__(63721);
// EXTERNAL MODULE: ./src/components/base/skeleton/TextSkeleton.tsx
var TextSkeleton = __webpack_require__(27869);
// EXTERNAL MODULE: ./src/utils/constants/User.ts
var constants_User = __webpack_require__(10848);
// EXTERNAL MODULE: ./src/redux/slice/Login/Login.tsx
var Login = __webpack_require__(31518);
;// CONCATENATED MODULE: ./src/components/profile/MyProfile.tsx




















var schema = lib.z.object({
    full_name: lib.z.string({
        required_error: ValidateMessage/* VALIDATE_REQUIRED */.yK
    }).min(3, {
        message: (0,ValidateMessage/* VALIDATE_MIN */.j)("Fullname", 3)
    }).max(100, {
        message: (0,ValidateMessage/* VALIDATE_MAX */.Ey)("Fullname", 100)
    })
});
var MyProfile = function(param) {
    var isEdit = param.isEdit, setIsEdit = param.setIsEdit, avatar = param.avatar, handleSetAvatar = param.handleSetAvatar, setReViewImageSrc = param.setReViewImageSrc, onOpenTab = param.onOpenTab;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var ref20 = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3), user = ref20.user, loading = ref20.loading, loadingEditName = ref20.loadingEditName;
    // Sử dụng hook useForm để quản lý form và xác thực dữ liệu
    var ref21 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(schema)
    }), control = ref21.control, setValue = ref21.setValue, handleSubmit = ref21.handleSubmit, reset = ref21.reset;
    var ref22 = (0,react.useState)(), makeDefaultDrawer = ref22[0], setMakeDefaultDrawer = ref22[1];
    /**
   * Hàm để chuyển sang chế độ chỉnh sửa form
   */ var handleChangeToEditForm = function() {
        var ref;
        // Đặt giá trị cho trường full_name bằng tên hiện tại của người dùng
        setValue("full_name", user === null || user === void 0 ? void 0 : (ref = user.detail) === null || ref === void 0 ? void 0 : ref.full_name);
        // Đặt trạng thái isEdit thành true
        setIsEdit(true);
    };
    /**
   * Hàm để chuyển sang chế độ view
   */ var handleChangeToPreview = function() {
        // Gọi hành động thunk open của confirmDialogThunk và chờ kết quả
        setIsEdit(false);
        // Đặt lại giá trị của form về ban đầu
        handleSetAvatar(undefined);
        setReViewImageSrc(undefined);
        reset({
            full_name: user.detail.full_name
        }, {
            keepDirty: false,
            keepErrors: false,
            keepDirtyValues: false,
            keepIsValid: false,
            keepTouched: false
        });
    };
    /**
   * Hàm để xử lý khi người dùng submit form
   * @param {{full_name: string}} data - Đối tượng chứa dữ liệu của form
   * @returns {Promise<void>} Một promise không có giá trị trả về
   */ var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var full_name, ref, error, ref1, ref2, ref3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        full_name = param.full_name;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            10
                        ]);
                        if (!(!avatar && (user === null || user === void 0 ? void 0 : (ref = user.detail) === null || ref === void 0 ? void 0 : ref.avatar))) return [
                            3,
                            3
                        ];
                        // Gọi hành động thunk updateUser để cập nhật tên và avatar của người dùng
                        return [
                            4,
                            dispatch((0,User/* updateUser */.Nq)({
                                full_name: full_name,
                                avatar: null
                            })).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        // Gọi hành động thunk getMe để lấy lại thông tin người dùng
                        dispatch((0,User/* getMe */.jo)());
                        // Đặt trạng thái isEdit thành false
                        setIsEdit(false);
                        return [
                            2
                        ];
                    case 3:
                        // Gọi hành động thunk updateUser để cập nhật tên của người dùng
                        return [
                            4,
                            dispatch((0,User/* updateUser */.Nq)({
                                full_name: full_name
                            })).unwrap()
                        ];
                    case 4:
                        _state.sent();
                        if (!avatar) return [
                            3,
                            6
                        ];
                        // Gọi hành động thunk updateUserAvatar để cập nhật avatar của người dùng
                        return [
                            4,
                            dispatch((0,User/* updateUserAvatar */.BA)(avatar)).unwrap()
                        ];
                    case 5:
                        _state.sent();
                        // Đặt lại giá trị của avatar
                        handleSetAvatar(undefined);
                        _state.label = 6;
                    case 6:
                        dispatch((0,User/* getMe */.jo)());
                        // Đặt trạng thái isEdit thành false
                        setIsEdit(false);
                        return [
                            3,
                            10
                        ];
                    case 7:
                        error = _state.sent();
                        setIsEdit(false);
                        setReViewImageSrc(undefined);
                        if (!((error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.error) === null || ref3 === void 0 ? void 0 : ref3.code) === "403|1002")) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            dispatch((0,Login/* getLogoutUser */.pW)())
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeMakeDefault = function() {
        setMakeDefaultDrawer(undefined);
    };
    var submitMakeDefault = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!(makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.id)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch((0,User/* makeContactDefault */.Iq)(makeDefaultDrawer.id)).unwrap().then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                setMakeDefaultDrawer(undefined);
                                                return [
                                                    4,
                                                    dispatch((0,User/* getMe */.jo)())
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitMakeDefault() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Sắp xếp mảng người dùng theo thời gian tạo và is_default.
   *
   * @param {Array} users - Mảng người dùng cần sắp xếp.
   * @returns {Array} - Mảng đã sắp xếp theo is_default và created_at.
   */ var sortByCreatedAtAndDefault = function(users) {
        var sortedUsers = (0,_to_consumable_array/* default */.Z)(users);
        sortedUsers.sort(function(a, b) {
            if ((a === null || a === void 0 ? void 0 : a.is_default) && !(b === null || b === void 0 ? void 0 : b.is_default)) return -1;
            if (!(a === null || a === void 0 ? void 0 : a.is_default) && (b === null || b === void 0 ? void 0 : b.is_default)) return 1;
            var dateA = new Date(a === null || a === void 0 ? void 0 : a.created_at);
            var dateB = new Date(b === null || b === void 0 ? void 0 : b.created_at);
            return (dateB === null || dateB === void 0 ? void 0 : dateB.getTime()) - (dateA === null || dateA === void 0 ? void 0 : dateA.getTime());
        });
        return sortedUsers;
    };
    var ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
                    title: "Overview",
                    headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex gap-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                                onClick: onOpenTab,
                                size: "medium",
                                title: "Back",
                                color: "textUnderline",
                                className: "block min-w-[120px] pr-0 text-base lg:hidden",
                                loading: loading && !isEdit
                            }),
                            !isEdit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                                onClick: handleChangeToEditForm,
                                size: "medium",
                                title: "Edit",
                                className: "min-w-[120px] text-base",
                                loading: loading && !isEdit
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancelSubmit/* default */.Z, {
                                className: "flex gap-12",
                                cancel: {
                                    title: "Cancel",
                                    onClick: handleChangeToPreview,
                                    size: "medium",
                                    isPaddingHorizontal: false,
                                    disabled: loading || loadingEditName,
                                    className: "min-w-fit !px-0 text-base w-30"
                                },
                                submit: {
                                    title: "Save",
                                    size: "medium",
                                    className: "min-w-fit px-0 text-sm w-30",
                                    type: "submit",
                                    loading: loading || loadingEditName
                                }
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "m-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Code",
                                        value: (ref23 = user === null || user === void 0 ? void 0 : (ref = user.code) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref23 !== void 0 ? ref23 : user === null || user === void 0 ? void 0 : (ref1 = user.key) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Full Name",
                                        isEdit: isEdit,
                                        loading: loading,
                                        children: isEdit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                            control: control,
                                            name: "full_name",
                                            skeleton: loadingEditName,
                                            className: "w-full flex-1"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "max-w-[300px] flex-auto font-medium text-bw-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                                                loading: loading && !isEdit,
                                                children: user.detail.full_name
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Username",
                                        value: user === null || user === void 0 ? void 0 : user.username,
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Role",
                                        value: (ref2 = constants_User/* USER_TYPE */.$A[user === null || user === void 0 ? void 0 : user.type]) === null || ref2 === void 0 ? void 0 : ref2.label,
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "D.O.B",
                                        value: (user === null || user === void 0 ? void 0 : (ref3 = user.detail) === null || ref3 === void 0 ? void 0 : ref3.dob) ? (0,helpers/* formatDate */.p6)(user === null || user === void 0 ? void 0 : (ref4 = user.detail) === null || ref4 === void 0 ? void 0 : ref4.dob, true) : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Email",
                                        value: user === null || user === void 0 ? void 0 : (ref5 = user.user_contacts) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.email,
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Phone",
                                        value: user === null || user === void 0 ? void 0 : (ref7 = user.user_contacts) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.phone,
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "University",
                                        value: (ref24 = user === null || user === void 0 ? void 0 : (ref9 = user.detail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.university) === null || ref10 === void 0 ? void 0 : ref10.name) !== null && ref24 !== void 0 ? ref24 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Major",
                                        value: user === null || user === void 0 ? void 0 : (ref11 = user.detail) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.major) === null || ref12 === void 0 ? void 0 : ref12.name,
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Field of work",
                                        value: (ref25 = user === null || user === void 0 ? void 0 : (ref13 = user.detail) === null || ref13 === void 0 ? void 0 : ref13.company_type) !== null && ref25 !== void 0 ? ref25 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Position",
                                        value: (ref26 = user === null || user === void 0 ? void 0 : (ref14 = user.detail) === null || ref14 === void 0 ? void 0 : ref14.company_position) !== null && ref26 !== void 0 ? ref26 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Main Class",
                                        value: (ref27 = user === null || user === void 0 ? void 0 : (ref15 = user.main_class) === null || ref15 === void 0 ? void 0 : ref15.join(",")) !== null && ref27 !== void 0 ? ref27 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Deferred/Retake class",
                                        value: (ref28 = user === null || user === void 0 ? void 0 : (ref16 = user.reserve_retook_class) === null || ref16 === void 0 ? void 0 : ref16.join(", ")) !== null && ref28 !== void 0 ? ref28 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Status",
                                        isEdit: isEdit,
                                        loading: loading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((ref17 = constants_User/* USER_STATUS */.iy[user === null || user === void 0 ? void 0 : user.status]) === null || ref17 === void 0 ? void 0 : ref17.color),
                                            children: (ref18 = constants_User/* USER_STATUS */.iy[user.status]) === null || ref18 === void 0 ? void 0 : ref18.label
                                        })
                                    }),
                                    !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                        title: "Updated At",
                                        value: (ref29 = (0,helpers/* formatDate */.p6)(user === null || user === void 0 ? void 0 : user.updated_at)) !== null && ref29 !== void 0 ? ref29 : "",
                                        isEdit: isEdit,
                                        loading: loading
                                    })
                                ]
                            }),
                            (ref19 = sortByCreatedAtAndDefault((user === null || user === void 0 ? void 0 : user.user_contacts) || [])) === null || ref19 === void 0 ? void 0 : ref19.map(function(e, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "border border-gray-3 p-4 ".concat(isEdit ? "bg-gray-3" : "", " "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-gray-1",
                                                        children: [
                                                            "Profile ",
                                                            i + 1
                                                        ]
                                                    }),
                                                    (e === null || e === void 0 ? void 0 : e.is_default) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-[10px] inline-block select-none bg-blue-600 bg-opacity-5 px-2 py-1 text-medium-sm leading-4 text-state-info",
                                                        children: "Default"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-3 flex font-medium text-bw-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-fit",
                                                        children: [
                                                            (e === null || e === void 0 ? void 0 : e.phone) && (e === null || e === void 0 ? void 0 : e.phone),
                                                            (e === null || e === void 0 ? void 0 : e.email) && (e === null || e === void 0 ? void 0 : e.phone) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "mx-3 text-gray-1",
                                                                children: "|"
                                                            }),
                                                            (e === null || e === void 0 ? void 0 : e.email) && (e === null || e === void 0 ? void 0 : e.email)
                                                        ]
                                                    }),
                                                    !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "group ml-auto w-fit cursor-pointer select-none",
                                                        onClick: function() {
                                                            return setMakeDefaultDrawer({
                                                                status: true,
                                                                email: e === null || e === void 0 ? void 0 : e.email,
                                                                phone: e === null || e === void 0 ? void 0 : e.phone,
                                                                address: e === null || e === void 0 ? void 0 : e.address,
                                                                index: i + 1,
                                                                id: e === null || e === void 0 ? void 0 : e.id,
                                                                is_default: e === null || e === void 0 ? void 0 : e.is_default
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: 24,
                                                            height: 24,
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                className: "fill-current text-gray-500 transition-colors duration-300 group-hover:text-primary",
                                                                d: "M13.102 19.147a.562.562 0 0 1 0-.795l5.79-5.79H3.75a.562.562 0 1 1 0-1.125h15.142l-5.79-5.79a.563.563 0 0 1 .796-.795l6.75 6.75a.563.563 0 0 1 0 .795l-6.75 6.75a.562.562 0 0 1-.796 0Z"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, e.id);
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SappDrawer/* default */.Z, {
                isOpen: (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.status) || false,
                onClose: closeMakeDefault,
                title: "Profile " + (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.index) || 0,
                message: "",
                confirmOnClose: false,
                widthDrawer: "w-6/12",
                btnSubmitTile: "Make Default",
                handleSubmit: submitMakeDefault,
                showSubmitButton: (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.is_default) ? false : true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-bw-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block w-[302px] text-gray-1",
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium",
                                children: (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.email) || ""
                            })
                        ]
                    }),
                    (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 text-bw-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block w-[302px] text-gray-1",
                                children: "Phone Number:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium",
                                children: [
                                    (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.phone) || "",
                                    " "
                                ]
                            })
                        ]
                    }),
                    (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 text-bw-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block w-[302px] text-gray-1",
                                children: [
                                    " ",
                                    "Address:",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium",
                                children: [
                                    (makeDefaultDrawer === null || makeDefaultDrawer === void 0 ? void 0 : makeDefaultDrawer.address) || "",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var TextWrapper = function(param) {
    var title = param.title, isEdit = param.isEdit, value = param.value, loading = param.loading, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "block gap-[1.4rem] md:flex ".concat(!isEdit ? "mb-5" : "mb-8 transition-[margin]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[17.43rem] max-w-[200px] flex-none text-gray-1 lg:max-w-[50%]",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[300px] flex-auto font-medium text-bw-1",
                children: [
                    value && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        loading: loading && !isEdit,
                        children: value
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ var profile_MyProfile = (MyProfile);

;// CONCATENATED MODULE: ./src/components/profile/ProfileContent.tsx


var ProfileContent = function(param) {
    var page = param.page, isEdit = param.isEdit, setIsEdit = param.setIsEdit, avatar = param.avatar, handleSetAvatar = param.handleSetAvatar, setReViewImageSrc = param.setReViewImageSrc, onOpenTab = param.onOpenTab;
    return page === "overview" && /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_MyProfile, {
        isEdit: isEdit,
        setIsEdit: setIsEdit,
        avatar: avatar,
        handleSetAvatar: handleSetAvatar,
        setReViewImageSrc: setReViewImageSrc,
        onOpenTab: onOpenTab
    });
};
/* harmony default export */ var profile_ProfileContent = (ProfileContent);

// EXTERNAL MODULE: ./src/assets/images/blank_avatar.webp
var blank_avatar = __webpack_require__(57213);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/bg_profile.svg
/* harmony default export */ var bg_profile = ({"src":"/_next/static/media/bg_profile.759ceb78.svg","height":200,"width":215});
;// CONCATENATED MODULE: ./src/components/profile/ProfileHeader.tsx









var ProfileHeader = function(param) {
    var isEdit = param.isEdit, setAvatar = param.setAvatar, inputFileRef = param.inputFileRef, reViewImageSrc = param.reViewImageSrc, setReViewImageSrc = param.setReViewImageSrc;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    // Sử dụng hook useAppSelector để lấy dữ liệu từ state redux
    var ref = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3), user = ref.user, loading = ref.loading, loadingEditName = ref.loadingEditName, loadingEditAvatar = ref.loadingEditAvatar;
    // Sử dụng state để lưu giá trị của hình ảnh xem trước
    /**
   * Một hàm để xử lý khi người dùng thay đổi file ảnh tải lên
   * @param {any} e - Đối tượng sự kiện của input file
   */ var handlerChangeUploadAvatar = function(e) {
        var ref;
        // Lấy file ảnh đầu tiên từ input file
        var file = (ref = e.target.files) === null || ref === void 0 ? void 0 : ref[0];
        // Kiểm tra xem file có đúng định dạng ảnh hay không
        if (!validateImage(file === null || file === void 0 ? void 0 : file.type, file === null || file === void 0 ? void 0 : file.size)) {
            return;
        }
        // Nếu có file
        if (file) {
            // Tạo một url tạm thời cho file ảnh
            var url = URL.createObjectURL(file);
            // Đặt giá trị cho state reViewImageSrc bằng url
            setReViewImageSrc(url);
            // Đặt giá trị cho state avatar bằng file
            setAvatar(file);
            // Xóa giá trị của input file
            if (inputFileRef.current) {
                inputFileRef.current.value = "";
            }
        }
    };
    /**
   * Một hàm để xử lý khi người dùng hủy bỏ việc tải ảnh lên
   */ var handlerCancelUploadAvatar = function() {
        // Đặt giá trị cho state reViewImageSrc bằng hình ảnh mặc định
        setReViewImageSrc(blank_avatar/* default */.Z);
        // Đặt giá trị cho state avatar thành undefined
        setAvatar(undefined);
    };
    /**
   * Một hàm để kiểm tra xem file có đúng định dạng ảnh hay không
   * @param {string} type - Loại file
   * @param {number} size - Kích thước file (tính bằng byte)
   * @returns {boolean} Một giá trị boolean cho biết file có đúng định dạng ảnh hay không
   */ var validateImage = function(type) {
        var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        // Tạo một mảng chứa các loại file ảnh được chấp nhận
        var acceptedTypes = [
            "image/jpg",
            "image/jpeg",
            "image/gif",
            "image/png"
        ];
        // Tạo một biến chứa kích thước file tối đa được chấp nhận (tính bằng byte)
        var maxSize = 20 * 1024 * 1024 // 20 MB
        ;
        // Nếu loại file không nằm trong mảng acceptedTypes
        if (!acceptedTypes.includes(type)) {
            // Hiển thị thông báo lỗi
            dist/* default.error */.ZP.error("File kh\xf4ng đ\xfang định dạng");
            // Trả về false
            return false;
        }
        // Nếu kích thước file vượt quá maxSize
        if (size > maxSize) {
            // Hiển thị thông báo lỗi
            dist/* default.error */.ZP.error("File qu\xe1 lớn, thước file vượt qu\xe1 20MB");
            // Trả về false
            return false;
        }
        // Trả về true
        return true;
    };
    (0,react.useEffect)(function() {
        dispatch((0,User/* getUserInformation */.gR)());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mb-6 block bg-white pl-10 shadow-box",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-start gap-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w relative my-6 w-30 shrink rounded-full border-2 border-primary pt-29.2 lg:my-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(loading ? "animate-pulse" : "", " w-100 h-100 absolute bottom-0 left-0 right-0 top-0 hidden overflow-hidden rounded-full lg:block"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute left-1/2 top-1/2 h-fit w-fit -translate-x-1/2 -translate-y-1/2 transform overflow-hidden rounded-full leading-[0]",
                                    children: [
                                        isEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "absolute bottom-0 left-0 right-0 top-0 z-10 cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "file",
                                                    className: "absolute bottom-0 left-0 right-0 top-0 z-10 h-full w-full cursor-pointer opacity-0",
                                                    onChange: handlerChangeUploadAvatar,
                                                    ref: inputFileRef
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex h-full w-full items-center justify-center bg-black opacity-40",
                                                    children: !loadingEditAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        width: "20",
                                                        height: "20",
                                                        viewBox: "0 0 20 20",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M19.2857 7.14314C19.2857 6.76425 19.1351 6.40089 18.8672 6.13298C18.5994 5.86508 18.2359 5.71456 17.8571 5.71456H14.9999L12.8571 2.85742H7.1428L4.99995 5.71456H2.1428C1.76392 5.71456 1.40056 5.86508 1.13265 6.13298C0.864743 6.40089 0.714233 6.76425 0.714233 7.14314V15.7146C0.714233 16.0934 0.864743 16.4569 1.13265 16.7247C1.40056 16.9926 1.76392 17.1431 2.1428 17.1431H17.8571C18.2359 17.1431 18.5994 16.9926 18.8672 16.7247C19.1351 16.4569 19.2857 16.0934 19.2857 15.7146V7.14314Z",
                                                                stroke: "white",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M9.99993 13.9286C11.7751 13.9286 13.2142 12.4895 13.2142 10.7143C13.2142 8.93909 11.7751 7.5 9.99993 7.5C8.22473 7.5 6.78564 8.93909 6.78564 10.7143C6.78564 12.4895 8.22473 13.9286 9.99993 13.9286Z",
                                                                stroke: "white",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        role: "status",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                "aria-hidden": "true",
                                                                className: "h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600",
                                                                viewBox: "0 0 100 101",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                                                        fill: "currentColor"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                                                        fill: "currentFill"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Loading..."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: reViewImageSrc || user.detail.avatar["150x150"] || user.detail.avatar["ORIGIN"] || blank_avatar/* default */.Z,
                                            alt: "avatar",
                                            className: "",
                                            width: 108,
                                            height: 108,
                                            layout: "fixed",
                                            objectFit: "cover",
                                            priority: true
                                        })
                                    ]
                                })
                            })
                        }),
                        isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "opacity-1 absolute bottom-2 right-0 z-10 w-fit",
                            onClick: handlerCancelUploadAvatar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-white shadow-box hover:text-state-error",
                                role: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: "1.5",
                                    stroke: "currentColor",
                                    className: "h-4 w-4 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-6 flex-1 lg:my-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4 max-w-[600px] truncate text-2xl font-bold text-bw-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                                loading: loading || loadingEditName,
                                children: user.detail.full_name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block items-center justify-start gap-8 text-gray-1 md:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-3 flex items-center justify-start gap-1.5 md:mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z",
                                                    stroke: "#A1A1A1",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z",
                                                    stroke: "#A1A1A1",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        user.courses,
                                        " Enrolled Courses"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-start gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z",
                                                    stroke: "#A1A1A1",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8.21 13.8909L7 23.0009L12 20.0009L17 23.0009L15.79 13.8809",
                                                    stroke: "#A1A1A1",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }),
                                        user.certificates,
                                        " Certificates"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: bg_profile,
                        className: "absolute right-0",
                        alt: "logo-watermark"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var profile_ProfileHeader = (ProfileHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67796);
// EXTERNAL MODULE: ./src/components/layout/ExpandIcon/index.tsx + 4 modules
var ExpandIcon = __webpack_require__(6675);
// EXTERNAL MODULE: ./src/utils/google-analytics.ts
var google_analytics = __webpack_require__(72158);
// EXTERNAL MODULE: ./src/utils/helpers/keycloak.ts + 6 modules
var keycloak = __webpack_require__(3787);
// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var constants = __webpack_require__(43743);
;// CONCATENATED MODULE: ./src/components/profile/ProfileSideBar.tsx
















var ProfileSideBar = function(param) {
    var page = param.page, children = param.children;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var getLabelFromChild = function(child) {
        if ("label" in child) {
            return child.label;
        } else if ("DEVICES" in child) {
            return child.DEVICES.label;
        } else if ("LOGIN_HISTORY" in child) {
            return child.LOGIN_HISTORY.label;
        } else if ("CHANGE_PASSWORD" in child) {
            return child.CHANGE_PASSWORD.label;
        } else if ("OVERVIEW" in child) {
            return child.OVERVIEW.label;
        } else if ("ACCA" in child) {
            return child.ACCA.label;
        } else if ("CFA" in child) {
            return child.CFA.label;
        } else if ("CMA" in child) {
            return child.CMA.label;
        }
        // Mặc định trả về chuỗi rỗng nếu không tìm thấy
        return "";
    };
    var handleLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var authenticationManager, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        authenticationManager = new keycloak/* AuthenticationManager */.E();
                        return [
                            4,
                            authenticationManager.logout()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    // Sử dụng useState để lưu trạng thái active của từng child
    var ref = (0,react.useState)({}), childActivationStates = ref[0], setChildActivationStates = ref[1];
    var handleSetStatusActiveChild = function(childLabel) {
        // Set the child and the "Security" page to active
        setChildActivationStates(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, childLabel, true));
        });
        // Set the active state of other children to false
        Object.keys(childActivationStates).forEach(function(key) {
            if (key !== childLabel) {
                setChildActivationStates(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, false));
                });
            }
        });
    };
    var handleChildClick = function(childLabel) {
        // Check if the clicked label is "Security"
        if ((childLabel === null || childLabel === void 0 ? void 0 : childLabel.toLowerCase()) === "security") {
            // Set both the "Security" page and the first child to active
            setChildActivationStates((0,_define_property/* default */.Z)({
                security: true
            }, Object.keys(childActivationStates)[0], true));
            return;
        }
        // Check if the clicked label is a child
        if (childActivationStates[childLabel]) {
            return; // If the child is already active, do nothing
        }
        handleSetStatusActiveChild(childLabel);
        // Chuyển trang
        var formattedChildLabel = childLabel === null || childLabel === void 0 ? void 0 : childLabel.toLowerCase();
        router.push("/".concat(formattedChildLabel));
    };
    var ref1 = (0,react.useState)({
        urlPage: "",
        isOpen: false
    }), isExpanded = ref1[0], toggleExpanded = ref1[1];
    /**
   * Hàm xử lý khi người dùng click vào nút mở rộng.
   * Chuyển trang đến trang con đầu tiên của trang hiện tại.
   *
   * @param {string} urlPage - Đường dẫn trang hiện tại.
   */ var onClickExpand = function(urlPage) {
        switch(urlPage){
            /**
       * Trang cá nhân hoặc trang bảo mật.
       */ case "myprofile":
            case "security":
                /**
         * Đổi trạng thái mở rộng của trang hiện tại.
         *
         * @param {object} prev - Trạng thái mở rộng trước đó.
         * @returns {object} - Trạng thái mở rộng mới.
         */ toggleExpanded(function(prev) {
                    return {
                        urlPage: urlPage,
                        isOpen: urlPage !== prev.urlPage ? true : !prev.isOpen
                    };
                });
                /**
         * Nếu đang ở trang cá nhân hoặc trang bảo mật, thì không cần chuyển trang.
         * Nếu không, chuyển đến trang con đầu tiên của trang hiện tại.
         */ if (constants_User/* MYPROFILE_TREE.includes */.kw.includes(router.query.page) && urlPage === "myprofile") {
                    handleSetStatusActiveChild(router.query.page);
                    break;
                }
                if (constants_User/* SECURITY_TREE.includes */.VD.includes(router.query.page) && urlPage === "security") {
                    handleSetStatusActiveChild(router.query.page);
                    break;
                }
                /**
         * Lấy danh sách trang con của trang hiện tại.
         *
         * @param {string} parentKey - Khóa của trang hiện tại.
         * @returns {array} - Danh sách trang con.
         */ var parentKey = urlPage.toUpperCase();
                var listChildren = constants_User/* PROFILE_PAGES */.$q[parentKey].children;
                /**
         * Lấy trang con đầu tiên.
         *
         * @param {array} listChildren - Danh sách trang con.
         * @returns {object} - Trang con đầu tiên.
         */ var firstChild = listChildren[0];
                /**
         * Lấy nhãn của trang con đầu tiên.
         *
         * @param {object} firstChild - Trang con đầu tiên.
         * @returns {string} - Nhãn của trang con đầu tiên.
         */ var firstChildKey = Object.keys(firstChild)[0];
                var firstChildLabel = firstChild === null || firstChild === void 0 ? void 0 : firstChild[firstChildKey];
                var firstChildLabelValue = getLabelFromChild(firstChildLabel);
                /**
         * Định dạng nhãn của trang con đầu tiên.
         *
         * @param {string} firstChildLabelValue - Nhãn của trang con đầu tiên.
         * @returns {string} - Nhãn định dạng.
         */ var formattedChildLabel = firstChildLabelValue.toLowerCase().replace(/\s+/g, "_");
                /**
         * Chuyển trang đến trang con đầu tiên.
         *
         * @param {string} formattedChildLabel - Nhãn định dạng.
         */ handleSetStatusActiveChild(formattedChildLabel);
                router.push("/".concat(formattedChildLabel));
                break;
            default:
                /**
         * Đổi trạng thái mở rộng của trang hiện tại.
         *
         * @param {object} - Trạng thái mở rộng mới.
         */ toggleExpanded({
                    urlPage: "",
                    isOpen: false
                });
                break;
        }
    };
    /**
   * Hàm xử lý khi người dùng click vào menu.
   * Xử lý dựa trên đường dẫn trang hiện tại và nhãn của trang con.
   *
   * @param {string} urlPage - Đường dẫn trang hiện tại.
   * @param {string} childLabel - Nhãn của trang con.
   */ var hanldeClickMenu = function(urlPage, childLabel) {
        switch(urlPage){
            case "myprofile":
                setChildActivationStates({
                    myprofile: true,
                    security: false
                });
                onClickExpand(urlPage);
                (0,google_analytics/* trackGAEvent */.wu)("Click Button Programs My Profile");
                break;
            case "security":
                setChildActivationStates({
                    security: true,
                    myprofile: false
                });
                onClickExpand(urlPage);
                (0,google_analytics/* trackGAEvent */.wu)("Click Button Security My Profile");
                break;
            default:
                setChildActivationStates({
                    security: false,
                    myprofile: false
                });
                handleChildClick(childLabel);
                onClickExpand("");
                (0,google_analytics/* trackGAEvent */.wu)("Click Button ".concat(childLabel, " My Profile"));
                break;
        }
    };
    (0,react.useEffect)(function() {
        var rootMenu = constants_User/* SECURITY_TREE.includes */.VD.includes(router.query.page) ? "security" : constants_User/* MYPROFILE_TREE.includes */.kw.includes(router.query.page) ? "myprofile" : null;
        rootMenu && onClickExpand(rootMenu);
        handleChildClick(router.query.page);
    }, []);
    (0,react.useEffect)(function() {
        // Check if the clicked label is a child
        if (childActivationStates[page]) {
            return; // If the child is already active, do nothing
        } else {
            handleSetStatusActiveChild(page);
            // if page is child of security or myprofile, set expanded
            if (constants_User/* SECURITY_TREE.includes */.VD.includes(page)) {
                toggleExpanded({
                    urlPage: "security",
                    isOpen: true
                });
            }
            if (constants_User/* MYPROFILE_TREE.includes */.kw.includes(page)) {
                toggleExpanded({
                    urlPage: "myprofile",
                    isOpen: true
                });
            }
        }
    }, [
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid w-full grid-cols-1 gap-6 lg:grid-cols-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full shadow-box",
                "data-aos": constants/* ANIMATION.DATA_AOS */.lB.DATA_AOS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "flex h-full flex-col justify-between bg-white px-3 py-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                Object.entries(constants_User/* PROFILE_PAGES */.$q).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                    var ref, ref1;
                                    var urlPage = key === null || key === void 0 ? void 0 : key.toLowerCase();
                                    var urlChildren = (value === null || value === void 0 ? void 0 : value.children) || [];
                                    var childLabel = (ref = getLabelFromChild(value)) === null || ref === void 0 ? void 0 : ref.replace(/\s+/g, "_");
                                    var isActive = urlPage === page;
                                    var className = "text-gray-1 relative hover:text-primary font-normal";
                                    if (isActive) {
                                        className = "bg-secondary font-medium text-primary";
                                    }
                                    if (childActivationStates[childLabel]) {
                                        className = "bg-secondary text-primary";
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "".concat(className, " group relative cursor-pointer border-b-[1px] border-gray-2"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "hover-transition-font-weight flex w-full justify-between p-5 text-left hover:bg-secondary  ".concat(isActive || urlPage === isExpanded.urlPage && ((ref1 = Object.values(childActivationStates)) === null || ref1 === void 0 ? void 0 : ref1.some(function(active) {
                                                    return active;
                                                })) && !childActivationStates[childLabel] ? "bg-secondary font-medium text-primary" : "font-normal "),
                                                style: {
                                                    position: "relative",
                                                    zIndex: 2
                                                },
                                                onClick: function() {
                                                    return hanldeClickMenu(urlPage, childLabel);
                                                },
                                                children: [
                                                    value === null || value === void 0 ? void 0 : value.label,
                                                    [
                                                        "security",
                                                        "myprofile"
                                                    ].includes(urlPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon/* default */.Z, {
                                                            isExpanded: isExpanded.isOpen && isExpanded.urlPage === urlPage,
                                                            type: "ontoggle",
                                                            className: ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            (urlChildren === null || urlChildren === void 0 ? void 0 : urlChildren.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx/* default */.Z)("ml-5 border-l border-gray-2", isExpanded.isOpen && isExpanded.urlPage === urlPage && "my-5"),
                                                children: isExpanded.isOpen && isExpanded.urlPage === urlPage && (urlChildren === null || urlChildren === void 0 ? void 0 : urlChildren.map(function(child) {
                                                    var ref, ref1;
                                                    var childLabel = (ref1 = (ref = getLabelFromChild(child)) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(/\s+/g, "_");
                                                    var childIsActive = childActivationStates[childLabel] || false;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(className, " hover-transition-font-weight relative ms-4 cursor-pointer hover:bg-secondary ").concat(childIsActive ? "bg-secondary font-medium text-primary" : "font-normal "),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block w-full p-3 text-left",
                                                            onClick: function() {
                                                                return handleChildClick(childLabel);
                                                            },
                                                            children: getLabelFromChild(child).toLowerCase() === "devices" ? "Browsers" : getLabelFromChild(child)
                                                        })
                                                    }, childLabel);
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hover-transition-font-weight relative top-px border-b border-gray-3 "
                                            })
                                        ]
                                    }, key);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "hover-transition-font-weight relative cursor-pointer p-5 font-normal text-gray-1 hover:bg-secondary hover:text-primary",
                                    onClick: handleLogout,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 bottom-0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Logout"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center text-sm font-normal text-gray-1",
                            children: "LMS Pro Version 2.8.0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-3 mb-6 hidden bg-white shadow-box lg:mb-0 lg:block",
                children: children
            })
        ]
    });
};
/* harmony default export */ var profile_ProfileSideBar = (ProfileSideBar);

;// CONCATENATED MODULE: ./src/components/profile/ProgramDetail.tsx












var ProgramDetail = function(param) {
    var typeProgram = param.typeProgram, onOpenTab = param.onOpenTab;
    var ref, ref1;
    var ref2 = (0,react.useState)(), subjects = ref2[0], setSubjects = ref2[1];
    var user = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3).user;
    var ref3 = (0,react.useState)(""), typeOfProgram = ref3[0], setTypeOfProgram = ref3[1];
    var ref4 = (0,react.useState)(), userProgram = ref4[0], setUserProgram = ref4[1];
    var ref5 = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit"
    }), setValue = ref5.setValue, control = ref5.control, resetField = ref5.resetField;
    /**
   * Hàm fetchSubjectOfHub dùng để lấy danh sách môn học từ API dựa trên loại chương trình (typeProgram).
   * Sau khi lấy dữ liệu thành công, cập nhật danh sách môn học vào state và thiết lập giá trị cho trường 'course_category_id'.
   */ var fetchSubjectOfHub = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, ref, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            profile/* default.getSubjectOfhubspot */.Z.getSubjectOfhubspot(typeProgram)
                        ];
                    case 1:
                        res = _state.sent();
                        // Cập nhật danh sách môn học vào state
                        setSubjects(res);
                        // Thiết lập giá trị cho trường 'course_category_id' trong form
                        setValue("course_category_id", (ref = res === null || res === void 0 ? void 0 : res.course_category_id) !== null && ref !== void 0 ? ref : "");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchSubjectOfHub() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Lấy thông tin chương trình học của người dùng dựa trên course_category_id.
   * @returns Thông tin chương trình học phù hợp với course_category_id của môn học.
   */ var programData = userProgram === null || userProgram === void 0 ? void 0 : (ref = userProgram.user_hubspot_program_infos) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.course_category_id) === (subjects === null || subjects === void 0 ? void 0 : subjects.course_category_id);
    });
    /**
   * useEffect để xử lý khi thông tin người dùng hoặc loại chương trình thay đổi.
   * - Nếu typeProgram thay đổi và khác với typeOfProgram hiện tại, cập nhật typeOfProgram và gọi hàm fetchSubjectOfHub.
   * - Thiết lập giá trị cho trường 'hubspot_account_info' trong form.
   */ (0,react.useEffect)(function() {
        if (user) {
            if (typeProgram && typeProgram !== typeOfProgram) {
                setTypeOfProgram(typeProgram) // Cập nhật loại chương trình
                ;
                fetchSubjectOfHub() // Lấy danh sách môn học từ API
                ;
            }
            var ref;
            // Thiết lập giá trị cho trường 'hubspot_account_info' trong form
            setValue("hubspot_account_info", (ref = programData === null || programData === void 0 ? void 0 : programData.hubspot_account_info) !== null && ref !== void 0 ? ref : "");
        }
    }, [
        resetField,
        setValue,
        typeOfProgram,
        typeProgram,
        user
    ]);
    function getUserProgram() {
        return _getUserProgram.apply(this, arguments);
    }
    function _getUserProgram() {
        _getUserProgram = /**
   * Hàm getUserProgram dùng để lấy thông tin chương trình học của người dùng từ API.
   * @returns Cập nhật thông tin chương trình học vào state userProgram.
   */ (0,_async_to_generator/* default */.Z)(function() {
            var res, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            api_user/* UserApi.getUserPrograms */.W.getUserPrograms(subjects === null || subjects === void 0 ? void 0 : subjects.course_category_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setUserProgram(res) // Cập nhật thông tin chương trình học vào state
                        ;
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getUserProgram.apply(this, arguments);
    }
    /**
   * useEffect để gọi hàm getUserProgram khi course_category_id của môn học thay đổi.
   * - Nếu course_category_id tồn tại, gọi hàm getUserProgram để lấy thông tin chương trình học.
   */ (0,react.useEffect)(function() {
        if (subjects === null || subjects === void 0 ? void 0 : subjects.course_category_id) {
            getUserProgram() // Lấy thông tin chương trình học
            ;
        }
    }, [
        subjects === null || subjects === void 0 ? void 0 : subjects.course_category_id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(profile_TabLayout, {
        title: typeProgram === "ACCA" ? "ACCA" : typeProgram === "CFA" ? "CFA" : "CMA",
        headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " flex gap-x-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                onClick: onOpenTab,
                size: "medium",
                title: "Back",
                color: "textUnderline",
                className: "block min-w-120 pr-0 text-base lg:hidden"
            })
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-1 flex w-[17.43rem] max-w-[200px] flex-none items-center text-gray-700 lg:max-w-[50%]",
                            children: "ACCOUNT ID:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-1 max-w-[300px] flex-auto font-medium text-bw-1",
                            children: programData === null || programData === void 0 ? void 0 : programData.hubspot_account_info
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "m-6",
                children: subjects === null || subjects === void 0 ? void 0 : (ref1 = subjects.subjects) === null || ref1 === void 0 ? void 0 : ref1.map(function(subject, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                    var courseTabData = userProgram === null || userProgram === void 0 ? void 0 : (ref = userProgram.course_tab_groups) === null || ref === void 0 ? void 0 : (ref1 = ref[typeProgram]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user_hubspot_examination_subjects) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
                        return item.examination_subject.subject.id === subject.id;
                    });
                    var ref7;
                    setValue("user_hubspot_examination_subjects.[".concat(index, "].result"), (ref7 = courseTabData === null || courseTabData === void 0 ? void 0 : courseTabData.result) !== null && ref7 !== void 0 ? ref7 : "");
                    var ref8;
                    setValue("user_hubspot_examination_subjects.[".concat(index, "].examination_subject_id"), (ref8 = courseTabData === null || courseTabData === void 0 ? void 0 : (ref3 = courseTabData.examination_subject) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.examination) === null || ref4 === void 0 ? void 0 : ref4.name) !== null && ref8 !== void 0 ? ref8 : "");
                    var ref9;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "font-ligth mb-3 flex flex-none items-center text-gray-700 lg:max-w-[50%]",
                                children: [
                                    subject === null || subject === void 0 ? void 0 : subject.name,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-5 grid grid-cols-2 rounded border p-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 mb-3 flex flex-none items-center text-gray-1 lg:max-w-[50%]",
                                        children: "Exam:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 mb-3 flex-auto font-medium text-bw-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                            control: control,
                                            disabled: true,
                                            name: "user_hubspot_examination_subjects.[".concat(index, "].examination_subject_id"),
                                            defaultValue: courseTabData === null || courseTabData === void 0 ? void 0 : (ref5 = courseTabData.examination_subject) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.examination) === null || ref6 === void 0 ? void 0 : ref6.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 flex flex-none items-center text-gray-1 lg:max-w-[50%]",
                                        children: "Result:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 flex-auto font-medium text-bw-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormTextField/* default */.Z, {
                                            control: control,
                                            disabled: true,
                                            name: "user_hubspot_examination_subjects.[".concat(index, "].result"),
                                            defaultValue: (ref9 = courseTabData === null || courseTabData === void 0 ? void 0 : courseTabData.result) !== null && ref9 !== void 0 ? ref9 : ""
                                        })
                                    })
                                ]
                            })
                        ]
                    }, "".concat(subject.id, "-").concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var profile_ProgramDetail = (ProgramDetail);

;// CONCATENATED MODULE: ./src/components/profile/Settings.tsx



var Settings = function(param) {
    var onBack = param.onBack;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: "flex h-full flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_TabLayout, {
                title: "Settings",
                headerButtons: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " flex gap-x-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCancelSubmit/* default */.Z, {
                        className: "flex gap-12",
                        cancel: {
                            title: "Cancel",
                            size: "medium",
                            isPaddingHorizontal: false,
                            disabled: false,
                            className: "min-w-fit !px-0 text-base w-30",
                            onClick: onBack
                        },
                        submit: {
                            title: "Save",
                            size: "medium",
                            className: "min-w-fit px-0 text-sm w-30",
                            type: "submit",
                            disabled: true
                        }
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-full items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-gray-1",
                        children: "Coming soon"
                    })
                })
            })
        })
    });
};
/* harmony default export */ var profile_Settings = (Settings);

// EXTERNAL MODULE: ./src/HOC/withAuthorization.tsx
var withAuthorization = __webpack_require__(94192);
// EXTERNAL MODULE: ./src/redux/types/User/urser.ts
var urser = __webpack_require__(7847);
// EXTERNAL MODULE: ./src/type/Profile.ts
var Profile = __webpack_require__(83401);
;// CONCATENATED MODULE: ./src/pages/[page]/index.tsx





















var ProfilePage = function() {
    var router = (0,next_router.useRouter)();
    var page = router.query.page;
    var ref = (0,react.useState)(false), isEdit = ref[0], setIsEdit = ref[1];
    var ref1 = (0,react.useState)(), avatar = ref1[0], setAvatar = ref1[1];
    var inputFileRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isSelectPage = ref2[0], setSelectPage = ref2[1];
    var ref3 = (0,react.useState)(), reViewImageSrc = ref3[0], setReViewImageSrc = ref3[1];
    var NotFound = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid h-full place-items-center p-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "justifycenter flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/images/image_404.jpg",
                        alt: "Image_404",
                        width: "320",
                        height: "260"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "mt-3 text-2xl font-bold text-bw-1 md:text-4xl",
                        children: "Tab Not Found"
                    })
                ]
            })
        });
    };
    var handleSetAvatar = function(avatar) {
        setAvatar(avatar);
    };
    var handleSetIsEdit = function(isEdit) {
        if (!isEdit && inputFileRef.current) {
            inputFileRef.current.value = "";
        }
        setIsEdit(isEdit);
    };
    var breadcrumbs = [
        {
            link: "/".concat(Profile/* ProfilePages.OVERVIEW */.D.OVERVIEW),
            title: "Profile"
        },
        {
            link: "/".concat(Profile/* ProfilePages.OVERVIEW */.D.OVERVIEW),
            title: "Details"
        }, 
    ];
    var selectedContent = null;
    switch(page){
        case Profile/* ProfilePages.Certificates */.D.Certificates:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_Certificate, {
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.Devices */.D.Devices:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_Devices, {
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.LoginHistory */.D.LoginHistory:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_LoginHistory, {
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.ChangePassword */.D.ChangePassword:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ChangePassword, {
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.Settings */.D.Settings:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_Settings, {
                onBack: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.OVERVIEW */.D.OVERVIEW:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProfileContent, {
                setReViewImageSrc: setReViewImageSrc,
                isEdit: isEdit,
                setIsEdit: handleSetIsEdit,
                page: page,
                avatar: avatar,
                handleSetAvatar: handleSetAvatar,
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.CFA */.D.CFA:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProgramDetail, {
                typeProgram: "CFA",
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.CMA */.D.CMA:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProgramDetail, {
                typeProgram: "CMA",
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.ACCA */.D.ACCA:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProgramDetail, {
                typeProgram: "ACCA",
                onOpenTab: function() {
                    return setSelectPage(true);
                }
            });
            break;
        case Profile/* ProfilePages.ExamInformation */.D.ExamInformation:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamInformation_ExamInfoTab, {
                onBack: function() {
                    return setSelectPage(true);
                }
            });
            break;
        default:
            selectedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {});
            break;
    }
    var handleResize = function() {
        if (window.innerWidth < 1024) {
            setSelectPage(false);
        } else {
            setSelectPage(true);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(function() {
        setSelectPage(window.innerWidth >= 1024);
    }, [
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        title: "My Profile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full w-full flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "border-b border-default bg-white px-4 lg:px-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto my-0 flex h-full max-w-xxl py-4.5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                            placeholder: "Enter name of course...",
                            formStyle: "w-full flex items-center"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto my-0 flex w-full max-w-xxl grow flex-col px-5 xl:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "main sm:mx-4 lg:mx-0 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbMyprofile, {
                                tabs: breadcrumbs,
                                currentPage: "Detail"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative",
                            "data-aos": constants/* ANIMATION.DATA_AOS */.lB.DATA_AOS,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProfileHeader, {
                                reViewImageSrc: reViewImageSrc,
                                setReViewImageSrc: setReViewImageSrc,
                                setAvatar: handleSetAvatar,
                                isEdit: isEdit,
                                inputFileRef: inputFileRef
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 flex w-full flex-grow flex-col items-stretch justify-between gap-6 sm:flex-row",
                            children: [
                                isSelectPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_ProfileSideBar, {
                                    page: page,
                                    children: selectedContent
                                }),
                                !isSelectPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-6 block w-full grow bg-white lg:mb-0 lg:hidden lg:grow-0",
                                    children: selectedContent
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
// export const getServerSideProps: GetServerSideProps<IProps> = async (
//   context,
// ) => {
//   const params = context.query
//   if (
//     !params?.page ||
//     typeof params?.page !== 'string'
//     // ||
//     // !PROFILE_PAGES[
//     //   (params?.page as string)?.toUpperCase() as keyof typeof PROFILE_PAGES
//     // ]
//   ) {
//     return {
//       notFound: true,
//     }
//   }
//   return {
//     props: { page: params?.page as IProfilePages },
//   }
// }
/* harmony default export */ var _page_ = ((0,withAuthorization/* default */.Z)([
    urser/* UserType.STUDENT */.F.STUDENT
])(ProfilePage));


/***/ }),

/***/ 83401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ProfilePages; }
/* harmony export */ });
var ProfilePages = {
    MyProfile: "myprofile",
    Certificates: "certificates",
    Settings: "settings",
    Logout: "logout",
    Devices: "devices",
    LoginHistory: "login_history",
    ExamInformation: "exam_information",
    ChangePassword: "change_password",
    OVERVIEW: "overview",
    STUDENTS: "students",
    TEACHING_PROGRESS: "teaching_progress",
    STUDENTS_TEST_RESULT: "students_test_result",
    CMA: "cma",
    CFA: "cfa",
    ACCA: "acca"
};


/***/ }),

/***/ 17332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ VALIDATE_PASSWORD; }
/* harmony export */ });
var VALIDATE_PASSWORD = /^(?=.*[A-Z])(?=.*\d).{8,}$/;



/***/ }),

/***/ 62179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ VALIDATE_MAX; },
/* harmony export */   "Ob": function() { return /* binding */ VALIDATE_PASSWORD_REGEX_MSG; },
/* harmony export */   "UE": function() { return /* binding */ VALIDATE_MIN_LENGTH_PASSWORD; },
/* harmony export */   "j": function() { return /* binding */ VALIDATE_MIN; },
/* harmony export */   "yK": function() { return /* binding */ VALIDATE_REQUIRED; }
/* harmony export */ });
/* unused harmony exports VALIDATE_MIN_LENGTH, SHOW_ERROR_USERNAME_PASSWORD, VALIDATE_LOGIN_EMAIL_REQUIRED, VALIDATE_PASSWORD_REQUIRED, SHOW_ERROR_ACCOUNT_LOCK */
var VALIDATE_REQUIRED = "This field is required";
var VALIDATE_LOGIN_EMAIL_REQUIRED = "The username/email field is required.";
var VALIDATE_PASSWORD_REQUIRED = "The password field is required.";
var VALIDATE_MIN = function(field, least) {
    return "".concat(field, " must contain at least ").concat(least, " character ").concat(least > 1 ? "(s)" : "");
};
var VALIDATE_MAX = function(field, most) {
    return "".concat(field, " must contain at most ").concat(most, " character ").concat(most > 1 ? "(s)" : "");
};
var VALIDATE_MIN_LENGTH = function(field, max) {
    return "".concat(field, " should be greater than ").concat(max, " character");
};
var VALIDATE_MIN_LENGTH_PASSWORD = function(field, max, letter, number) {
    return "".concat(field, " must be at least ").concat(max, " character, ").concat(letter, " uppercase letter, ").concat(number, " number");
};
var VALIDATE_PASSWORD_REGEX_MSG = "Password must be at least 8 characters, 1 uppercase letter, 1 number";
1;
var SHOW_ERROR_USERNAME_PASSWORD = "Invalid username/email or password, please check again";
var SHOW_ERROR_ACCOUNT_LOCK = "Your account has been locked.";



/***/ }),

/***/ 25925:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5367,7017,6458,5901,8679,5604,9946,1193,2270,63,9774,2888,179], function() { return __webpack_exec__(71941); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);